export class CONSTANTS {
  static readonly DASHBOARD_NAV_TITLE = 'DASHBOARD.NAV.TITLE';
  static readonly DASHBOARD_NAV_HOME = 'DASHBOARD.NAV.HOME';
  static readonly DASHBOARD_NAV_CLIENTS = 'DASHBOARD.NAV.CLIENTS';
  static readonly DASHBOARD_NAV_CASES = 'DASHBOARD.NAV.CASES';
  static readonly DASHBOARD_NAV_TASKS = 'DASHBOARD.NAV.TASKS';
  static readonly DASHBOARD_NAV_LEGAL_CASES = 'DASHBOARD.NAV.LEGAL_CASES';
  static readonly DASHBOARD_NAV_FILES = 'DASHBOARD.NAV.FILES';
  static readonly DASHBOARD_NAV_NOTES = 'DASHBOARD.NAV.NOTES';
  static readonly DASHBOARD_NAV_CALENDAR = 'DASHBOARD.NAV.CALENDAR';
  static readonly DASHBOARD_NAV_APPOINTMENTS = 'DASHBOARD.NAV.APPOINTMENTS';

  /** PrimeNG DatePicker / calendar locale translations (from bg.json CALENDAR) */
  static readonly CALENDAR = 'CALENDAR';
  static readonly CALENDAR_DAY_NAMES = 'CALENDAR.DAY_NAMES';
  static readonly CALENDAR_DAY_NAMES_SHORT = 'CALENDAR.DAY_NAMES_SHORT';
  static readonly CALENDAR_DAY_NAMES_MIN = 'CALENDAR.DAY_NAMES_MIN';
  static readonly CALENDAR_MONTH_NAMES = 'CALENDAR.MONTH_NAMES';
  static readonly CALENDAR_MONTH_NAMES_SHORT = 'CALENDAR.MONTH_NAMES_SHORT';
  static readonly CALENDAR_FIRST_DAY_OF_WEEK = 'CALENDAR.FIRST_DAY_OF_WEEK';
  static readonly CALENDAR_TODAY = 'CALENDAR.TODAY';
  static readonly CALENDAR_CLEAR = 'CALENDAR.CLEAR';
  static readonly CALENDAR_WEEK_HEADER = 'CALENDAR.WEEK_HEADER';

  static readonly DASHBOARD_HEADER_TITLE = 'DASHBOARD.HEADER.TITLE';
  static readonly DASHBOARD_HEADER_SUBTITLE = 'DASHBOARD.HEADER.SUBTITLE';

  static readonly DASHBOARD_CARD_TOTAL_CLIENTS = 'DASHBOARD.CARDS.TOTAL_CLIENTS';
  static readonly DASHBOARD_CARD_OPEN_CASES = 'DASHBOARD.CARDS.OPEN_CASES';
  static readonly DASHBOARD_CARD_OPEN_ISSUES = 'DASHBOARD.CARDS.OPEN_ISSUES';

  static readonly NAVBAR_VIEW_PROFILE = 'NAVBAR.VIEW_PROFILE';
  static readonly NAVBAR_PROFILE_SETTINGS = 'NAVBAR.PROFILE_SETTINGS';
  static readonly NAVBAR_LOGOUT = 'NAVBAR.LOGOUT';

  static readonly PROFILE_SETTINGS_TITLE = 'PROFILE.SETTINGS.TITLE';
  static readonly PROFILE_SETTINGS_SUBTITLE = 'PROFILE.SETTINGS.SUBTITLE';
  static readonly PROFILE_SETTINGS_PLACEHOLDER = 'PROFILE.SETTINGS.PLACEHOLDER';
  static readonly PROFILE_SETTINGS_SECTION_PERSONAL = 'PROFILE.SETTINGS.SECTIONS.PERSONAL';
  static readonly PROFILE_SETTINGS_SECTION_FIRM = 'PROFILE.SETTINGS.SECTIONS.FIRM';
  static readonly PROFILE_SETTINGS_SECTION_PROFESSIONAL = 'PROFILE.SETTINGS.SECTIONS.PROFESSIONAL';
  static readonly PROFILE_SETTINGS_SECTION_ECASE = 'PROFILE.SETTINGS.SECTIONS.ECASE';
  static readonly PROFILE_SETTINGS_SECTION_NOTIFICATIONS = 'PROFILE.SETTINGS.SECTIONS.NOTIFICATIONS';
  static readonly PROFILE_SETTINGS_SECTION_SECURITY = 'PROFILE.SETTINGS.SECTIONS.SECURITY';
  static readonly PROFILE_SETTINGS_SECTION_TEAM = 'PROFILE.SETTINGS.SECTIONS.TEAM';
  static readonly PROFILE_SETTINGS_SECTION_SUBSCRIPTION = 'PROFILE.SETTINGS.SECTIONS.SUBSCRIPTION';
  static readonly PROFILE_SETTINGS_SECTION_DELETE = 'PROFILE.SETTINGS.SECTIONS.DELETE';
  static readonly PROFILE_SETTINGS_PERSONAL_TITLE = 'PROFILE.SETTINGS.PERSONAL.TITLE';
  static readonly PROFILE_SETTINGS_PERSONAL_SUBTITLE = 'PROFILE.SETTINGS.PERSONAL.SUBTITLE';
  static readonly PROFILE_SETTINGS_FIRST_NAME = 'PROFILE.SETTINGS.PERSONAL.FIRST_NAME';
  static readonly PROFILE_SETTINGS_LAST_NAME = 'PROFILE.SETTINGS.PERSONAL.LAST_NAME';
  static readonly PROFILE_SETTINGS_EMAIL = 'PROFILE.SETTINGS.PERSONAL.EMAIL';
  /** Solo practice: one line "bar / EGN" (editable). */
  static readonly PROFILE_SETTINGS_BAR_NUMBER_EGN = 'PROFILE.SETTINGS.PERSONAL.BAR_NUMBER_EGN';
  static readonly PROFILE_SETTINGS_POSITION = 'PROFILE.SETTINGS.PERSONAL.POSITION';
  static readonly PROFILE_SETTINGS_ROLE_EMPLOYEE = 'PROFILE.SETTINGS.PERSONAL.ROLE.ROLE_EMPLOYEE';
  static readonly PROFILE_SETTINGS_ROLE_OFFICE_MANAGER = 'PROFILE.SETTINGS.PERSONAL.ROLE.ROLE_OFFICE_MANAGER';
  static readonly PROFILE_SETTINGS_FIRM_SECTION_TITLE = 'PROFILE.SETTINGS.PERSONAL.FIRM.SECTION_TITLE';
  static readonly PROFILE_SETTINGS_FIRM_SECTION_SUBTITLE = 'PROFILE.SETTINGS.PERSONAL.FIRM.SECTION_SUBTITLE';
  static readonly PROFILE_SETTINGS_FIRM_NAME = 'PROFILE.SETTINGS.PERSONAL.FIRM.NAME';
  static readonly PROFILE_SETTINGS_FIRM_UIC = 'PROFILE.SETTINGS.PERSONAL.FIRM.UIC';
  static readonly PROFILE_SETTINGS_FIRM_BAR_NUMBER = 'PROFILE.SETTINGS.PERSONAL.FIRM.BAR_NUMBER';
  static readonly PROFILE_SETTINGS_FIRM_ADDRESS = 'PROFILE.SETTINGS.PERSONAL.FIRM.ADDRESS';
  static readonly PROFILE_SETTINGS_FIRM_REPRESENTATIVES = 'PROFILE.SETTINGS.PERSONAL.FIRM.REPRESENTATIVES';
  static readonly PROFILE_SETTINGS_UPLOAD_LOGO = 'PROFILE.SETTINGS.PERSONAL.FIRM.UPLOAD_LOGO';
  static readonly PROFILE_SETTINGS_REMOVE_LOGO = 'PROFILE.SETTINGS.PERSONAL.FIRM.REMOVE_LOGO';
  static readonly PROFILE_SETTINGS_PHOTO_HINT = 'PROFILE.SETTINGS.PERSONAL.PHOTO_HINT';
  static readonly PROFILE_SETTINGS_UPLOAD_PHOTO = 'PROFILE.SETTINGS.PERSONAL.UPLOAD_PHOTO';
  static readonly PROFILE_SETTINGS_REMOVE_PHOTO = 'PROFILE.SETTINGS.PERSONAL.REMOVE_PHOTO';
  static readonly PROFILE_SETTINGS_SAVE = 'PROFILE.SETTINGS.PERSONAL.SAVE';
  static readonly PROFILE_SETTINGS_SAVE_SUCCESS = 'PROFILE.SETTINGS.PERSONAL.SAVE_SUCCESS';
  static readonly PROFILE_SETTINGS_SAVE_FAILED = 'PROFILE.SETTINGS.PERSONAL.SAVE_FAILED';
  static readonly PROFILE_SETTINGS_LOAD_FAILED = 'PROFILE.SETTINGS.PERSONAL.LOAD_FAILED';
  static readonly PROFILE_SETTINGS_TEAM_TITLE = 'PROFILE.SETTINGS.TEAM.TITLE';
  static readonly PROFILE_SETTINGS_TEAM_SUBTITLE = 'PROFILE.SETTINGS.TEAM.SUBTITLE';
  static readonly PROFILE_SETTINGS_TEAM_INVITE = 'PROFILE.SETTINGS.TEAM.INVITE';
  static readonly PROFILE_SETTINGS_TEAM_INVITE_TOAST = 'PROFILE.SETTINGS.TEAM.INVITE_TOAST';
  static readonly PROFILE_SETTINGS_TEAM_LOAD_FAILED = 'PROFILE.SETTINGS.TEAM.LOAD_FAILED';

  static readonly PROFILE_MODAL_TITLE = 'PROFILE.MODAL.TITLE';
  static readonly PROFILE_MODAL_SUBTITLE = 'PROFILE.MODAL.SUBTITLE';
  static readonly PROFILE_MODAL_EDIT_BUTTON = 'PROFILE.MODAL.EDIT_BUTTON';
  static readonly PROFILE_MODAL_ADMIN_BADGE = 'PROFILE.MODAL.ADMIN_BADGE';
  static readonly PROFILE_MODAL_ACTIVE_CASES = 'PROFILE.MODAL.ACTIVE_CASES';

  static readonly PROFILE_CONTACT_TITLE = 'PROFILE.CONTACT.TITLE';
  static readonly PROFILE_CONTACT_EMAIL = 'PROFILE.CONTACT.EMAIL';
  static readonly PROFILE_CONTACT_PHONE = 'PROFILE.CONTACT.PHONE';
  static readonly PROFILE_CONTACT_OFFICE = 'PROFILE.CONTACT.OFFICE';
  static readonly PROFILE_CONTACT_JOIN_DATE = 'PROFILE.CONTACT.JOIN_DATE';

  static readonly PROFILE_PROFESSIONAL_TITLE = 'PROFILE.PROFESSIONAL.TITLE';
  static readonly PROFILE_PROFESSIONAL_SPECIALIZATIONS = 'PROFILE.PROFESSIONAL.SPECIALIZATIONS';
  static readonly PROFILE_PROFESSIONAL_CASES_HANDLED = 'PROFILE.PROFESSIONAL.CASES_HANDLED';
  static readonly PROFILE_PROFESSIONAL_ACTIVE_CASES = 'PROFILE.PROFESSIONAL.ACTIVE_CASES';

  static readonly PROFILE_SECURITY_TITLE = 'PROFILE.SECURITY.TITLE';
  static readonly PROFILE_SECURITY_CHANGE_PASSWORD = 'PROFILE.SECURITY.CHANGE_PASSWORD';
  static readonly PROFILE_SECURITY_CHANGE_PASSWORD_SUBTITLE = 'PROFILE.SECURITY.CHANGE_PASSWORD_SUBTITLE';
  static readonly PROFILE_SECURITY_TWO_FACTOR = 'PROFILE.SECURITY.TWO_FACTOR';
  static readonly PROFILE_SECURITY_TWO_FACTOR_SUBTITLE = 'PROFILE.SECURITY.TWO_FACTOR_SUBTITLE';

  static readonly TOAST_LOGIN_SUCCESS_SUMMARY = 'TOAST.LOGIN_SUCCESS.SUMMARY';
  static readonly TOAST_LOGIN_SUCCESS_DETAIL = 'TOAST.LOGIN_SUCCESS.DETAIL';
  static readonly TOAST_LOGIN_FAILED_SUMMARY = 'TOAST.LOGIN_FAILED.SUMMARY';
  static readonly TOAST_LOGIN_FAILED_DETAIL = 'TOAST.LOGIN_FAILED.DETAIL';

  static readonly TOAST_LOGOUT_SUCCESS_SUMMARY = 'TOAST.LOGOUT_SUCCESS.SUMMARY';
  static readonly TOAST_LOGOUT_SUCCESS_DETAIL = 'TOAST.LOGOUT_SUCCESS.DETAIL';
  static readonly TOAST_LOGOUT_FAILED_SUMMARY = 'TOAST.LOGOUT_FAILED.SUMMARY';
  static readonly TOAST_LOGOUT_FAILED_DETAIL = 'TOAST.LOGOUT_FAILED.DETAIL';

  static readonly TOAST_REGISTER_SUCCESS_SUMMARY = 'TOAST.REGISTER_SUCCESS.SUMMARY';
  static readonly TOAST_REGISTER_SUCCESS_DETAIL = 'TOAST.REGISTER_SUCCESS.DETAIL';
  static readonly TOAST_REGISTER_FAILED_SUMMARY = 'TOAST.REGISTER_FAILED.SUMMARY';
  static readonly TOAST_REGISTER_FAILED_DETAIL_REQUIRED = 'TOAST.REGISTER_FAILED.DETAIL_REQUIRED';
  static readonly TOAST_REGISTER_FAILED_DETAIL_RETRY = 'TOAST.REGISTER_FAILED.DETAIL_RETRY';
  static readonly TOAST_REGISTER_FAILED_CONFLICT_EMAIL = 'TOAST.REGISTER_FAILED.CONFLICT_EMAIL';
  static readonly TOAST_REGISTER_FAILED_CONFLICT_USERNAME = 'TOAST.REGISTER_FAILED.CONFLICT_USERNAME';
  static readonly TOAST_REGISTER_FAILED_CONFLICT_BOTH = 'TOAST.REGISTER_FAILED.CONFLICT_BOTH';
  static readonly TOAST_REGISTER_FAILED_CONFLICT_GENERIC = 'TOAST.REGISTER_FAILED.CONFLICT_GENERIC';

  static readonly LEGAL_TERMS_PATH = '/legal/terms';
  static readonly LEGAL_PRIVACY_PATH = '/legal/privacy';

  static readonly LEGAL_INFO_TERMS_TITLE = 'LEGAL_INFO.TERMS_TITLE';
  static readonly LEGAL_INFO_PRIVACY_TITLE = 'LEGAL_INFO.PRIVACY_TITLE';

  static readonly AUTH_REGISTER_TITLE = 'AUTH.REGISTER.TITLE';
  static readonly AUTH_REGISTER_STEP_1 = 'AUTH.REGISTER.STEP_1';
  static readonly AUTH_REGISTER_STEP_2 = 'AUTH.REGISTER.STEP_2';
  static readonly AUTH_REGISTER_STEP_3 = 'AUTH.REGISTER.STEP_3';
  static readonly AUTH_REGISTER_FIRST_NAME = 'AUTH.REGISTER.FIRST_NAME';
  static readonly AUTH_REGISTER_LAST_NAME = 'AUTH.REGISTER.LAST_NAME';
  static readonly AUTH_REGISTER_EMAIL = 'AUTH.REGISTER.EMAIL';
  static readonly AUTH_REGISTER_USERNAME = 'AUTH.REGISTER.USERNAME';
  static readonly AUTH_REGISTER_PASSWORD = 'AUTH.REGISTER.PASSWORD';
  static readonly AUTH_REGISTER_CONFIRM_PASSWORD = 'AUTH.REGISTER.CONFIRM_PASSWORD';
  static readonly AUTH_REGISTER_FIELD_REQUIRED = 'AUTH.REGISTER.FIELD_REQUIRED';
  static readonly AUTH_REGISTER_PWD_MIN_LENGTH = 'AUTH.REGISTER.PWD_MIN_LENGTH';
  static readonly AUTH_REGISTER_PWD_HAS_UPPER = 'AUTH.REGISTER.PWD_HAS_UPPER';
  static readonly AUTH_REGISTER_PWD_HAS_LOWER = 'AUTH.REGISTER.PWD_HAS_LOWER';
  static readonly AUTH_REGISTER_PWD_HAS_DIGIT = 'AUTH.REGISTER.PWD_HAS_DIGIT';
  static readonly AUTH_REGISTER_PWD_HAS_SPECIAL = 'AUTH.REGISTER.PWD_HAS_SPECIAL';
  static readonly AUTH_REGISTER_SHOW_PASSWORD = 'AUTH.REGISTER.SHOW_PASSWORD';
  static readonly AUTH_REGISTER_HIDE_PASSWORD = 'AUTH.REGISTER.HIDE_PASSWORD';
  static readonly AUTH_REGISTER_NEXT = 'AUTH.REGISTER.NEXT';
  static readonly AUTH_REGISTER_BACK = 'AUTH.REGISTER.BACK';
  static readonly AUTH_REGISTER_SUBMIT = 'AUTH.REGISTER.SUBMIT';
  static readonly AUTH_REGISTER_CHOOSE_ACTION = 'AUTH.REGISTER.CHOOSE_ACTION';
  static readonly AUTH_REGISTER_TYPE_NEW_BUREAU_TITLE = 'AUTH.REGISTER.TYPE_NEW_BUREAU_TITLE';
  static readonly AUTH_REGISTER_TYPE_NEW_BUREAU_DESC = 'AUTH.REGISTER.TYPE_NEW_BUREAU_DESC';
  static readonly AUTH_REGISTER_TYPE_EXISTING_BUREAU_TITLE = 'AUTH.REGISTER.TYPE_EXISTING_BUREAU_TITLE';
  static readonly AUTH_REGISTER_TYPE_EXISTING_BUREAU_DESC = 'AUTH.REGISTER.TYPE_EXISTING_BUREAU_DESC';
  static readonly AUTH_REGISTER_TYPE_ATTORNEY_TITLE = 'AUTH.REGISTER.TYPE_ATTORNEY_TITLE';
  static readonly AUTH_REGISTER_TYPE_ATTORNEY_DESC = 'AUTH.REGISTER.TYPE_ATTORNEY_DESC';
  static readonly AUTH_REGISTER_NEW_BUREAU_INFO_TITLE = 'AUTH.REGISTER.NEW_BUREAU_INFO_TITLE';
  static readonly AUTH_REGISTER_NEW_BUREAU_INFO_DESC = 'AUTH.REGISTER.NEW_BUREAU_INFO_DESC';
  static readonly AUTH_REGISTER_BUREAU_NAME = 'AUTH.REGISTER.BUREAU_NAME';
  static readonly AUTH_REGISTER_BUREAU_UIC_LABEL = 'AUTH.REGISTER.BUREAU_UIC_LABEL';
  static readonly AUTH_REGISTER_BUREAU_COUNTRY = 'AUTH.REGISTER.BUREAU_COUNTRY';
  static readonly AUTH_REGISTER_BUREAU_CITY = 'AUTH.REGISTER.BUREAU_CITY';
  static readonly AUTH_REGISTER_BUREAU_POSTAL_CODE = 'AUTH.REGISTER.BUREAU_POSTAL_CODE';
  static readonly AUTH_REGISTER_BUREAU_ADDRESS = 'AUTH.REGISTER.BUREAU_ADDRESS';
  static readonly AUTH_REGISTER_BUREAU_REPRESENTATIVES = 'AUTH.REGISTER.BUREAU_REPRESENTATIVES';
  static readonly AUTH_REGISTER_EXISTING_BUREAU_INFO_TITLE = 'AUTH.REGISTER.EXISTING_BUREAU_INFO_TITLE';
  static readonly AUTH_REGISTER_EXISTING_BUREAU_INFO_DESC = 'AUTH.REGISTER.EXISTING_BUREAU_INFO_DESC';
  static readonly AUTH_REGISTER_ATTORNEY_TAB_BAR = 'AUTH.REGISTER.ATTORNEY_TAB_BAR';
  static readonly AUTH_REGISTER_ATTORNEY_TAB_BAR_LINE_1 = 'AUTH.REGISTER.ATTORNEY_TAB_BAR_LINE_1';
  static readonly AUTH_REGISTER_ATTORNEY_TAB_BAR_LINE_2 = 'AUTH.REGISTER.ATTORNEY_TAB_BAR_LINE_2';
  static readonly AUTH_REGISTER_ATTORNEY_TAB_EGN = 'AUTH.REGISTER.ATTORNEY_TAB_EGN';
  static readonly AUTH_REGISTER_ATTORNEY_BAR_NUMBER = 'AUTH.REGISTER.ATTORNEY_BAR_NUMBER';
  static readonly AUTH_REGISTER_ATTORNEY_BAR_NOTE = 'AUTH.REGISTER.ATTORNEY_BAR_NOTE';
  static readonly AUTH_REGISTER_ATTORNEY_EGN = 'AUTH.REGISTER.ATTORNEY_EGN';
  static readonly AUTH_REGISTER_EGN_INVALID = 'AUTH.REGISTER.EGN_INVALID';
  static readonly AUTH_REGISTER_ATTORNEY_EGN_NOTE = 'AUTH.REGISTER.ATTORNEY_EGN_NOTE';
  static readonly AUTH_REGISTER_TERMS_ACCEPT_PREFIX = 'AUTH.REGISTER.TERMS_ACCEPT_PREFIX';
  static readonly AUTH_REGISTER_TERMS_LINK_TERMS = 'AUTH.REGISTER.TERMS_LINK_TERMS';
  static readonly AUTH_REGISTER_TERMS_CONJUNCTION = 'AUTH.REGISTER.TERMS_CONJUNCTION';
  static readonly AUTH_REGISTER_TERMS_LINK_PRIVACY = 'AUTH.REGISTER.TERMS_LINK_PRIVACY';
  static readonly AUTH_REGISTER_TERMS_REQUIRED = 'AUTH.REGISTER.TERMS_REQUIRED';
  static readonly AUTH_REGISTER_SUCCESS_TITLE = 'AUTH.REGISTER.SUCCESS_TITLE';
  static readonly AUTH_REGISTER_SUCCESS_DESC = 'AUTH.REGISTER.SUCCESS_DESC';
  static readonly AUTH_REGISTER_TO_SYSTEM = 'AUTH.REGISTER.TO_SYSTEM';
  static readonly AUTH_REGISTER_FOOTER_PREFIX = 'AUTH.REGISTER.FOOTER_PREFIX';
  static readonly AUTH_REGISTER_LOGIN_LINK = 'AUTH.REGISTER.LOGIN_LINK';
  static readonly AUTH_REGISTER_EMAIL_REQUIRED = 'AUTH.REGISTER.EMAIL_REQUIRED';
  static readonly AUTH_REGISTER_EMAIL_INVALID = 'AUTH.REGISTER.EMAIL_INVALID';
  static readonly AUTH_REGISTER_EMAIL_EXISTS = 'AUTH.REGISTER.EMAIL_EXISTS';
  static readonly AUTH_REGISTER_USERNAME_REQUIRED = 'AUTH.REGISTER.USERNAME_REQUIRED';
  static readonly AUTH_REGISTER_USERNAME_EXISTS = 'AUTH.REGISTER.USERNAME_EXISTS';
  static readonly AUTH_REGISTER_CONFIRM_PASSWORD_REQUIRED = 'AUTH.REGISTER.CONFIRM_PASSWORD_REQUIRED';
  static readonly AUTH_REGISTER_PASSWORDS_MISMATCH = 'AUTH.REGISTER.PASSWORDS_MISMATCH';
  static readonly AUTH_REGISTER_BUREAU_UIC_REQUIRED = 'AUTH.REGISTER.BUREAU_UIC_REQUIRED';
  static readonly AUTH_REGISTER_BUREAU_UIC_FORMAT = 'AUTH.REGISTER.BUREAU_UIC_FORMAT';
  static readonly AUTH_REGISTER_BUREAU_UIC_NOT_IN_SYSTEM = 'AUTH.REGISTER.BUREAU_UIC_NOT_IN_SYSTEM';

  static readonly TOAST_CASE_ADDED_SUMMARY = 'TOAST.CASE_ADDED.SUMMARY';
  static readonly TOAST_CASE_ADDED_DETAIL = 'TOAST.CASE_ADDED.DETAIL';
  static readonly TOAST_CASE_ADD_FAILED_SUMMARY = 'TOAST.CASE_ADD_FAILED.SUMMARY';
  static readonly TOAST_CASE_ADD_FAILED_DETAIL = 'TOAST.CASE_ADD_FAILED.DETAIL';
  static readonly TOAST_CASE_UPDATED_SUMMARY = 'TOAST.CASE_UPDATED.SUMMARY';
  static readonly TOAST_CASE_UPDATED_DETAIL = 'TOAST.CASE_UPDATED.DETAIL';
  static readonly TOAST_CASE_UPDATE_FAILED_SUMMARY = 'TOAST.CASE_UPDATE_FAILED.SUMMARY';
  static readonly TOAST_CASE_UPDATE_FAILED_DETAIL = 'TOAST.CASE_UPDATE_FAILED.DETAIL';
  static readonly TOAST_CASE_DELETED_SUMMARY = 'TOAST.CASE_DELETED.SUMMARY';
  static readonly TOAST_CASE_DELETED_DETAIL = 'TOAST.CASE_DELETED.DETAIL';
  static readonly TOAST_CASE_DELETE_FAILED_SUMMARY = 'TOAST.CASE_DELETE_FAILED.SUMMARY';
  static readonly TOAST_CASE_DELETE_FAILED_DETAIL = 'TOAST.CASE_DELETE_FAILED.DETAIL';

  static readonly TOAST_CLIENT_ADDED_SUMMARY = 'TOAST.CLIENT_ADDED.SUMMARY';
  static readonly TOAST_CLIENT_ADDED_DETAIL = 'TOAST.CLIENT_ADDED.DETAIL';
  static readonly TOAST_CLIENT_ADD_FAILED_SUMMARY = 'TOAST.CLIENT_ADD_FAILED.SUMMARY';
  static readonly TOAST_CLIENT_ADD_FAILED_DETAIL = 'TOAST.CLIENT_ADD_FAILED.DETAIL';
  static readonly TOAST_CLIENT_UPDATED_SUMMARY = 'TOAST.CLIENT_UPDATED.SUMMARY';
  static readonly TOAST_CLIENT_UPDATED_DETAIL = 'TOAST.CLIENT_UPDATED.DETAIL';
  static readonly TOAST_CLIENT_UPDATE_FAILED_SUMMARY = 'TOAST.CLIENT_UPDATE_FAILED.SUMMARY';
  static readonly TOAST_CLIENT_UPDATE_FAILED_DETAIL = 'TOAST.CLIENT_UPDATE_FAILED.DETAIL';
  static readonly TOAST_CLIENT_DELETED_SUMMARY = 'TOAST.CLIENT_DELETED.SUMMARY';
  static readonly TOAST_CLIENT_DELETED_DETAIL = 'TOAST.CLIENT_DELETED.DETAIL';
  static readonly TOAST_CLIENT_DELETE_FAILED_SUMMARY = 'TOAST.CLIENT_DELETE_FAILED.SUMMARY';
  static readonly TOAST_CLIENT_DELETE_FAILED_DETAIL = 'TOAST.CLIENT_DELETE_FAILED.DETAIL';

  static readonly TOAST_TASK_ADDED_SUMMARY = 'TOAST.TASK_ADDED.SUMMARY';
  static readonly TOAST_TASK_ADDED_DETAIL = 'TOAST.TASK_ADDED.DETAIL';
  static readonly TOAST_TASK_ADD_FAILED_SUMMARY = 'TOAST.TASK_ADD_FAILED.SUMMARY';
  static readonly TOAST_TASK_ADD_FAILED_DETAIL = 'TOAST.TASK_ADD_FAILED.DETAIL';
  static readonly TOAST_TASK_UPDATED_SUMMARY = 'TOAST.TASK_UPDATED.SUMMARY';
  static readonly TOAST_TASK_UPDATED_DETAIL = 'TOAST.TASK_UPDATED.DETAIL';
  static readonly TOAST_TASK_UPDATE_FAILED_SUMMARY = 'TOAST.TASK_UPDATE_FAILED.SUMMARY';
  static readonly TOAST_TASK_UPDATE_FAILED_DETAIL = 'TOAST.TASK_UPDATE_FAILED.DETAIL';
  static readonly TOAST_TASK_DELETED_SUMMARY = 'TOAST.TASK_DELETED.SUMMARY';
  static readonly TOAST_TASK_DELETED_DETAIL = 'TOAST.TASK_DELETED.DETAIL';
  static readonly TOAST_TASK_DELETE_FAILED_SUMMARY = 'TOAST.TASK_DELETE_FAILED.SUMMARY';
  static readonly TOAST_TASK_DELETE_FAILED_DETAIL = 'TOAST.TASK_DELETE_FAILED.DETAIL';

  static readonly TOAST_TASK_NOTE_ADDED_SUMMARY = 'TOAST.TASK_NOTE_ADDED.SUMMARY';
  static readonly TOAST_TASK_NOTE_ADDED_DETAIL = 'TOAST.TASK_NOTE_ADDED.DETAIL';
  static readonly TOAST_TASK_NOTE_UPDATED_SUMMARY = 'TOAST.TASK_NOTE_UPDATED.SUMMARY';
  static readonly TOAST_TASK_NOTE_UPDATED_DETAIL = 'TOAST.TASK_NOTE_UPDATED.DETAIL';
  static readonly TOAST_TASK_NOTE_DELETED_SUMMARY = 'TOAST.TASK_NOTE_DELETED.SUMMARY';
  static readonly TOAST_TASK_NOTE_DELETED_DETAIL = 'TOAST.TASK_NOTE_DELETED.DETAIL';
  static readonly TOAST_TASK_NOTE_ADD_FAILED_SUMMARY = 'TOAST.TASK_NOTE_ADD_FAILED.SUMMARY';
  static readonly TOAST_TASK_NOTE_ADD_FAILED_DETAIL = 'TOAST.TASK_NOTE_ADD_FAILED.DETAIL';
  static readonly TOAST_TASK_NOTE_UPDATE_FAILED_SUMMARY = 'TOAST.TASK_NOTE_UPDATE_FAILED.SUMMARY';
  static readonly TOAST_TASK_NOTE_UPDATE_FAILED_DETAIL = 'TOAST.TASK_NOTE_UPDATE_FAILED.DETAIL';
  static readonly TOAST_TASK_NOTE_DELETE_FAILED_SUMMARY = 'TOAST.TASK_NOTE_DELETE_FAILED.SUMMARY';
  static readonly TOAST_TASK_NOTE_DELETE_FAILED_DETAIL = 'TOAST.TASK_NOTE_DELETE_FAILED.DETAIL';

  static readonly TOAST_FILE_UPLOAD_SUCCESS_SUMMARY = 'TOAST.FILE_UPLOAD_SUCCESS.SUMMARY';
  static readonly TOAST_FILE_UPLOAD_SUCCESS_DETAIL = 'TOAST.FILE_UPLOAD_SUCCESS.DETAIL';
  static readonly TOAST_FILE_UPLOAD_FAILED_SUMMARY = 'TOAST.FILE_UPLOAD_FAILED.SUMMARY';
  static readonly TOAST_FILE_UPLOAD_FAILED_DETAIL = 'TOAST.FILE_UPLOAD_FAILED.DETAIL';
  static readonly TOAST_FILE_DELETED_SUMMARY = 'TOAST.FILE_DELETED.SUMMARY';
  static readonly TOAST_FILE_DELETED_DETAIL = 'TOAST.FILE_DELETED.DETAIL';
  static readonly TOAST_FILE_DELETE_FAILED_SUMMARY = 'TOAST.FILE_DELETE_FAILED.SUMMARY';
  static readonly TOAST_FILE_DELETE_FAILED_DETAIL = 'TOAST.FILE_DELETE_FAILED.DETAIL';
  static readonly TOAST_FILE_PREVIEW_FAILED_SUMMARY = 'TOAST.FILE_PREVIEW_FAILED.SUMMARY';
  static readonly TOAST_FILE_PREVIEW_FAILED_DETAIL = 'TOAST.FILE_PREVIEW_FAILED.DETAIL';
  static readonly TOAST_FILE_DOWNLOAD_FAILED_SUMMARY = 'TOAST.FILE_DOWNLOAD_FAILED.SUMMARY';
  static readonly TOAST_FILE_DOWNLOAD_FAILED_DETAIL = 'TOAST.FILE_DOWNLOAD_FAILED.DETAIL';
  static readonly TOAST_FILE_SERVER_ERROR_SUMMARY = 'TOAST.FILE_SERVER_ERROR.SUMMARY';
  static readonly TOAST_FILE_SERVER_ERROR_DETAIL = 'TOAST.FILE_SERVER_ERROR.DETAIL';

  static readonly TOAST_LEGAL_CASE_LOAD_FAILED_SUMMARY = 'TOAST.LEGAL_CASE_LOAD_FAILED.SUMMARY';
  static readonly TOAST_LEGAL_CASE_LOAD_FAILED_DETAIL = 'TOAST.LEGAL_CASE_LOAD_FAILED.DETAIL';
  static readonly TOAST_LEGAL_CASE_ADDED_SUMMARY = 'TOAST.LEGAL_CASE_ADDED.SUMMARY';
  static readonly TOAST_LEGAL_CASE_ADDED_DETAIL = 'TOAST.LEGAL_CASE_ADDED.DETAIL';
  static readonly TOAST_LEGAL_CASE_ADD_FAILED_SUMMARY = 'TOAST.LEGAL_CASE_ADD_FAILED.SUMMARY';
  static readonly TOAST_LEGAL_CASE_ADD_FAILED_DETAIL = 'TOAST.LEGAL_CASE_ADD_FAILED.DETAIL';
  static readonly TOAST_LEGAL_CASE_UPDATED_SUMMARY = 'TOAST.LEGAL_CASE_UPDATED.SUMMARY';
  static readonly TOAST_LEGAL_CASE_UPDATED_DETAIL = 'TOAST.LEGAL_CASE_UPDATED.DETAIL';
  static readonly TOAST_LEGAL_CASE_UPDATE_FAILED_SUMMARY = 'TOAST.LEGAL_CASE_UPDATE_FAILED.SUMMARY';
  static readonly TOAST_LEGAL_CASE_UPDATE_FAILED_DETAIL = 'TOAST.LEGAL_CASE_UPDATE_FAILED.DETAIL';
  static readonly TOAST_LEGAL_CASE_DELETED_SUMMARY = 'TOAST.LEGAL_CASE_DELETED.SUMMARY';
  static readonly TOAST_LEGAL_CASE_DELETED_DETAIL = 'TOAST.LEGAL_CASE_DELETED.DETAIL';
  static readonly TOAST_LEGAL_CASE_DELETE_FAILED_SUMMARY = 'TOAST.LEGAL_CASE_DELETE_FAILED.SUMMARY';
  static readonly TOAST_LEGAL_CASE_DELETE_FAILED_DETAIL = 'TOAST.LEGAL_CASE_DELETE_FAILED.DETAIL';

  static readonly CLIENTS_PAGE_TITLE = 'CLIENTS.PAGE.TITLE';
  static readonly CLIENTS_SEARCH_PLACEHOLDER = 'CLIENTS.SEARCH.PLACEHOLDER';
  static readonly CLIENTS_TABLE_CLIENT_TYPE = 'CLIENTS.TABLE.CLIENT_TYPE';
  static readonly CLIENTS_TABLE_NAME = 'CLIENTS.TABLE.NAME';
  static readonly CLIENTS_TABLE_IDENTIFIER = 'CLIENTS.TABLE.IDENTIFIER';
  static readonly CLIENTS_TABLE_EMAIL = 'CLIENTS.TABLE.EMAIL';
  static readonly CLIENTS_TABLE_TELEPHONE = 'CLIENTS.TABLE.TELEPHONE';
  static readonly CLIENTS_TABLE_ACTIONS = 'CLIENTS.TABLE.ACTIONS';
  static readonly CLIENTS_TABLE_NO_RESULTS = 'CLIENTS.TABLE.NO_RESULTS';
  static readonly CLIENTS_TABLE_VIEW_TOOLTIP = 'CLIENTS.TABLE.VIEW_TOOLTIP';
  static readonly CLIENTS_TABLE_EDIT_TOOLTIP = 'CLIENTS.TABLE.EDIT_TOOLTIP';
  static readonly CLIENTS_TABLE_DELETE_TOOLTIP = 'CLIENTS.TABLE.DELETE_TOOLTIP';
  static readonly CLIENTS_PAGINATION_SHOWING = 'CLIENTS.PAGINATION.SHOWING';
  static readonly CLIENTS_PAGINATION_TO = 'CLIENTS.PAGINATION.TO';
  static readonly CLIENTS_PAGINATION_OF = 'CLIENTS.PAGINATION.OF';
  static readonly CLIENTS_PAGINATION_RECORDS = 'CLIENTS.PAGINATION.RECORDS';
  static readonly CLIENTS_PAGINATION_PER_PAGE = 'CLIENTS.PAGINATION.PER_PAGE';

  static readonly CLIENT_TYPE_PERSON = 'CLIENTS.TYPE.PERSON';
  static readonly CLIENT_TYPE_FIRM = 'CLIENTS.TYPE.FIRM';
  static readonly CLIENT_TYPE_SOLE_TRADER = 'CLIENTS.TYPE.SOLE_TRADER';
  static readonly CLIENT_TYPE_NON_PROFIT = 'CLIENTS.TYPE.NON_PROFIT';
  static readonly CLIENT_TYPE_PARTNERSHIP = 'CLIENTS.TYPE.PARTNERSHIP';

  static readonly CLIENT_TYPE_SHORT_PERSON = 'CLIENTS.TYPE_SHORT.PERSON';
  static readonly CLIENT_TYPE_SHORT_FIRM = 'CLIENTS.TYPE_SHORT.FIRM';
  static readonly CLIENT_TYPE_SHORT_SOLE_TRADER = 'CLIENTS.TYPE_SHORT.SOLE_TRADER';
  static readonly CLIENT_TYPE_SHORT_NON_PROFIT = 'CLIENTS.TYPE_SHORT.NON_PROFIT';
  static readonly CLIENT_TYPE_SHORT_PARTNERSHIP = 'CLIENTS.TYPE_SHORT.PARTNERSHIP';

  static readonly CLIENT_DIALOG_ADD_TITLE = 'CLIENTS.DIALOG.ADD_TITLE';
  static readonly CLIENT_DIALOG_EDIT_TITLE = 'CLIENTS.DIALOG.EDIT_TITLE';
  static readonly CLIENT_DIALOG_ADD_DESCRIPTION = 'CLIENTS.DIALOG.ADD_DESCRIPTION';
  static readonly CLIENT_DIALOG_EDIT_DESCRIPTION = 'CLIENTS.DIALOG.EDIT_DESCRIPTION';
  static readonly CLIENT_DIALOG_CLIENT_TYPE = 'CLIENTS.DIALOG.CLIENT_TYPE';
  static readonly CLIENT_DIALOG_CLIENT_DETAILS = 'CLIENTS.DIALOG.CLIENT_DETAILS';
  static readonly CLIENT_DIALOG_ADDRESS = 'CLIENTS.DIALOG.ADDRESS';
  static readonly CLIENT_DIALOG_CONTACT_INFO = 'CLIENTS.DIALOG.CONTACT_INFO';
  static readonly CLIENT_DIALOG_CANCEL = 'CLIENTS.DIALOG.CANCEL';
  static readonly CLIENT_DIALOG_SAVE = 'CLIENTS.DIALOG.SAVE';
  static readonly CLIENT_DIALOG_SAVE_CHANGES = 'CLIENTS.DIALOG.SAVE_CHANGES';

  static readonly CLIENT_FORM_FIRST_NAME = 'CLIENTS.FORM.FIRST_NAME';
  static readonly CLIENT_FORM_SURNAME = 'CLIENTS.FORM.SURNAME';
  static readonly CLIENT_FORM_LAST_NAME = 'CLIENTS.FORM.LAST_NAME';
  static readonly CLIENT_FORM_EGN = 'CLIENTS.FORM.EGN';
  static readonly CLIENT_FORM_FIRM_NAME = 'CLIENTS.FORM.FIRM_NAME';
  static readonly CLIENT_FORM_UIC = 'CLIENTS.FORM.UIC';
  static readonly CLIENT_FORM_REPRESENTATIVE = 'CLIENTS.FORM.REPRESENTATIVE';
  static readonly CLIENT_FORM_LEGAL_FORM = 'CLIENTS.FORM.LEGAL_FORM';
  static readonly CLIENT_FORM_COUNTRY = 'CLIENTS.FORM.COUNTRY';
  static readonly CLIENT_FORM_CITY = 'CLIENTS.FORM.CITY';
  static readonly CLIENT_FORM_POSTAL_CODE = 'CLIENTS.FORM.POSTAL_CODE';
  static readonly CLIENT_FORM_FULL_ADDRESS = 'CLIENTS.FORM.FULL_ADDRESS';
  static readonly CLIENT_FORM_EMAIL = 'CLIENTS.FORM.EMAIL';
  static readonly CLIENT_FORM_TELEPHONE = 'CLIENTS.FORM.TELEPHONE';

  static readonly CLIENT_DELETE_CONFIRM_HEADER = 'CLIENTS.DELETE.CONFIRM_HEADER';
  static readonly CLIENT_DELETE_CONFIRM_MESSAGE = 'CLIENTS.DELETE.CONFIRM_MESSAGE';
  static readonly CLIENT_DELETE_ACCEPT = 'CLIENTS.DELETE.ACCEPT';
  static readonly CLIENT_DELETE_REJECT = 'CLIENTS.DELETE.REJECT';

  static readonly CLIENT_PLACEHOLDER_FIRST_NAME = 'CLIENTS.PLACEHOLDER.FIRST_NAME';
  static readonly CLIENT_PLACEHOLDER_SURNAME = 'CLIENTS.PLACEHOLDER.SURNAME';
  static readonly CLIENT_PLACEHOLDER_LAST_NAME = 'CLIENTS.PLACEHOLDER.LAST_NAME';
  static readonly CLIENT_PLACEHOLDER_EGN = 'CLIENTS.PLACEHOLDER.EGN';
  static readonly CLIENT_PLACEHOLDER_FIRM_NAME = 'CLIENTS.PLACEHOLDER.FIRM_NAME';
  static readonly CLIENT_PLACEHOLDER_UIC = 'CLIENTS.PLACEHOLDER.UIC';
  static readonly CLIENT_PLACEHOLDER_BULSTAT = 'CLIENTS.PLACEHOLDER.BULSTAT';
  static readonly CLIENT_PLACEHOLDER_REPRESENTATIVE = 'CLIENTS.PLACEHOLDER.REPRESENTATIVE';
  static readonly CLIENT_PLACEHOLDER_LEGAL_FORM = 'CLIENTS.PLACEHOLDER.LEGAL_FORM';
  static readonly CLIENT_PLACEHOLDER_TRADER = 'CLIENTS.PLACEHOLDER.TRADER';
  static readonly CLIENT_PLACEHOLDER_COUNTRY = 'CLIENTS.PLACEHOLDER.COUNTRY';
  static readonly CLIENT_PLACEHOLDER_CITY = 'CLIENTS.PLACEHOLDER.CITY';
  static readonly CLIENT_PLACEHOLDER_POSTAL_CODE = 'CLIENTS.PLACEHOLDER.POSTAL_CODE';
  static readonly CLIENT_PLACEHOLDER_FULL_ADDRESS = 'CLIENTS.PLACEHOLDER.FULL_ADDRESS';
  static readonly CLIENT_PLACEHOLDER_EMAIL = 'CLIENTS.PLACEHOLDER.EMAIL';
  static readonly CLIENT_PLACEHOLDER_TELEPHONE = 'CLIENTS.PLACEHOLDER.TELEPHONE';
  static readonly CLIENT_PLACEHOLDER_FORM_OF_REPRESENTATION = 'CLIENTS.PLACEHOLDER.FORM_OF_REPRESENTATION';

  static readonly CLIENT_FORM_FOR_FUTURE_INTEGRATION = 'CLIENTS.FORM.FOR_FUTURE_INTEGRATION';
  static readonly CLIENT_FORM_FETCH_PLACEHOLDER_UIC = 'CLIENTS.FORM.FETCH_PLACEHOLDER_UIC';
  static readonly CLIENT_FORM_FETCH_PLACEHOLDER_BULSTAT = 'CLIENTS.FORM.FETCH_PLACEHOLDER_BULSTAT';
  static readonly CLIENT_FORM_FETCH_BUTTON = 'CLIENTS.FORM.FETCH_BUTTON';
  static readonly CLIENT_FORM_FETCH_HINT_UIC = 'CLIENTS.FORM.FETCH_HINT_UIC';
  static readonly CLIENT_FORM_FETCH_HINT_BULSTAT = 'CLIENTS.FORM.FETCH_HINT_BULSTAT';
  static readonly CLIENT_FORM_TRADER_LABEL = 'CLIENTS.FORM.TRADER_LABEL';
  static readonly CLIENT_FORM_FORM_OF_REPRESENTATION_LABEL = 'CLIENTS.FORM.FORM_OF_REPRESENTATION_LABEL';
  static readonly CLIENT_FORM_FORM_OF_REPRESENTATION_SEPARATE = 'CLIENTS.FORM.FORM_OF_REPRESENTATION_SEPARATE';
  static readonly CLIENT_FORM_FORM_OF_REPRESENTATION_JOINT = 'CLIENTS.FORM.FORM_OF_REPRESENTATION_JOINT';
  static readonly CLIENT_FORM_FORM_OF_REPRESENTATION_OTHER = 'CLIENTS.FORM.FORM_OF_REPRESENTATION_OTHER';

  static readonly CLIENT_DETAIL_BACK = 'CLIENTS.DETAIL.BACK';
  static readonly CLIENT_DETAIL_LOADING = 'CLIENTS.DETAIL.LOADING';
  static readonly CLIENT_DETAIL_CLIENT_DATA = 'CLIENTS.DETAIL.CLIENT_DATA';
  static readonly CLIENT_DETAIL_CONTACTS = 'CLIENTS.DETAIL.CONTACTS';
  static readonly CLIENT_DETAIL_NAME_LABEL = 'CLIENTS.DETAIL.NAME_LABEL';
  static readonly CLIENT_DETAIL_EGN_LABEL = 'CLIENTS.DETAIL.EGN_LABEL';
  static readonly CLIENT_DETAIL_UIC_LABEL = 'CLIENTS.DETAIL.UIC_LABEL';
  static readonly CLIENT_DETAIL_BULSTAT_LABEL = 'CLIENTS.DETAIL.BULSTAT_LABEL';
  static readonly CLIENT_DETAIL_REPRESENTATIVE_LABEL = 'CLIENTS.DETAIL.REPRESENTATIVE_LABEL';
  static readonly CLIENT_DETAIL_TRADER_LABEL = 'CLIENTS.DETAIL.TRADER_LABEL';
  static readonly CLIENT_DETAIL_LEGAL_FORM_LABEL = 'CLIENTS.DETAIL.LEGAL_FORM_LABEL';
  static readonly CLIENT_DETAIL_ADDRESS_LABEL = 'CLIENTS.DETAIL.ADDRESS_LABEL';
  static readonly CLIENT_DETAIL_HEADQUARTERS_LABEL = 'CLIENTS.DETAIL.HEADQUARTERS_LABEL';
  static readonly CLIENT_DETAIL_CORRESPONDENCE_ADDRESS = 'CLIENTS.DETAIL.CORRESPONDENCE_ADDRESS';
  static readonly CLIENT_DETAIL_NOTES = 'CLIENTS.DETAIL.NOTES';
  static readonly CLIENT_DETAIL_NO_NOTES = 'CLIENTS.DETAIL.NO_NOTES';
  static readonly CLIENT_DETAIL_DEADLINES = 'CLIENTS.DETAIL.DEADLINES';
  static readonly CLIENT_DETAIL_NO_DEADLINES = 'CLIENTS.DETAIL.NO_DEADLINES';
  static readonly CLIENT_DETAIL_TAB_LEGAL_CASES = 'CLIENTS.DETAIL.TAB_LEGAL_CASES';
  static readonly CLIENT_DETAIL_TAB_CASES = 'CLIENTS.DETAIL.TAB_CASES';
  static readonly CLIENT_DETAIL_TAB_TASKS = 'CLIENTS.DETAIL.TAB_TASKS';
  static readonly CLIENT_DETAIL_TAB_ENTRIES = 'CLIENTS.DETAIL.TAB_ENTRIES';

  static readonly CLIENT_IDENTIFIER_TYPE_EGN = 'CLIENTS.IDENTIFIER_TYPE.EGN';
  static readonly CLIENT_IDENTIFIER_TYPE_UIC = 'CLIENTS.IDENTIFIER_TYPE.UIC';
  static readonly CLIENT_IDENTIFIER_TYPE_BULSTAT = 'CLIENTS.IDENTIFIER_TYPE.BULSTAT';
  static readonly CLIENT_DETAIL_NO_LEGAL_CASES = 'CLIENTS.DETAIL.NO_LEGAL_CASES';
  static readonly CLIENT_DETAIL_NO_CASES = 'CLIENTS.DETAIL.NO_CASES';
  static readonly CLIENT_DETAIL_NO_TASKS = 'CLIENTS.DETAIL.NO_TASKS';
  static readonly CLIENT_DETAIL_NO_ENTRIES = 'CLIENTS.DETAIL.NO_ENTRIES';
  static readonly CLIENT_DETAIL_CASE_NUMBER = 'CLIENTS.DETAIL.CASE_NUMBER';
  static readonly CLIENT_DETAIL_STATUS_ACTIVE = 'CLIENTS.DETAIL.STATUS_ACTIVE';
  static readonly CLIENT_DETAIL_STATUS_PENDING = 'CLIENTS.DETAIL.STATUS_PENDING';
  static readonly CLIENT_DETAIL_STATUS_CLOSED = 'CLIENTS.DETAIL.STATUS_CLOSED';
  static readonly CLIENT_DETAIL_EXAMPLE_CASE_TITLE = 'CLIENTS.DETAIL.EXAMPLE_CASE_TITLE';
  static readonly CLIENT_DETAIL_EXAMPLE_CASE_DESC = 'CLIENTS.DETAIL.EXAMPLE_CASE_DESC';

  static readonly CASES_PAGE_TITLE = 'CASES.PAGE.TITLE';
  static readonly CASES_PAGE_SEARCH_PLACEHOLDER = 'CASES.PAGE.SEARCH_PLACEHOLDER';
  static readonly CASES_PAGE_TABLE_TITLE = 'CASES.PAGE.TABLE_TITLE';
  static readonly CASES_PAGE_TABLE_DESCRIPTION = 'CASES.PAGE.TABLE_DESCRIPTION';
  static readonly CASES_PAGE_TABLE_CASE_NAME = 'CASES.PAGE.TABLE_CASE_NAME';
  static readonly CASES_PAGE_TABLE_LEGAL_CASE = 'CASES.PAGE.TABLE_LEGAL_CASE';
  static readonly CASES_PAGE_TABLE_CLIENT = 'CASES.PAGE.TABLE_CLIENT';
  static readonly CASES_PAGE_TABLE_STATUS = 'CASES.PAGE.TABLE_STATUS';
  static readonly CASES_PAGE_TABLE_TASKS = 'CASES.PAGE.TABLE_TASKS';
  static readonly CASES_PAGE_TABLE_ACTIONS = 'CASES.PAGE.TABLE_ACTIONS';
  static readonly CASES_PAGE_TABLE_NO_RESULTS = 'CASES.PAGE.TABLE_NO_RESULTS';
  static readonly CASES_PAGE_STATUS_OPEN = 'CASES.PAGE.STATUS_OPEN';
  static readonly CASES_PAGE_STATUS_CLOSED = 'CASES.PAGE.STATUS_CLOSED';
  static readonly CASES_PAGE_TOOLTIP_VIEW = 'CASES.PAGE.TOOLTIP_VIEW';
  static readonly CASES_PAGE_TOOLTIP_EDIT = 'CASES.PAGE.TOOLTIP_EDIT';
  static readonly CASES_PAGE_TOOLTIP_DELETE = 'CASES.PAGE.TOOLTIP_DELETE';
  static readonly CASES_PAGE_DELETE_CONFIRM_HEADER = 'CASES.PAGE.DELETE_CONFIRM_HEADER';
  static readonly CASES_PAGE_DELETE_CONFIRM_MESSAGE = 'CASES.PAGE.DELETE_CONFIRM_MESSAGE';
  static readonly CASES_PAGE_DELETE_ACCEPT = 'CASES.PAGE.DELETE_ACCEPT';
  static readonly CASES_PAGE_DELETE_REJECT = 'CASES.PAGE.DELETE_REJECT';
  static readonly CASES_PAGE_EDIT_STATUS_TOOLTIP = 'CASES.PAGE.EDIT_STATUS_TOOLTIP';
  static readonly CASES_PAGINATION_SHOWING = 'CASES.PAGINATION.SHOWING';
  static readonly CASES_PAGINATION_TO = 'CASES.PAGINATION.TO';
  static readonly CASES_PAGINATION_OF = 'CASES.PAGINATION.OF';
  static readonly CASES_PAGINATION_RECORDS = 'CASES.PAGINATION.RECORDS';
  static readonly CASES_PAGINATION_PER_PAGE = 'CASES.PAGINATION.PER_PAGE';

  static readonly LEGAL_CASES_PAGE_TITLE = 'LEGAL_CASES.PAGE.TITLE';
  static readonly LEGAL_CASES_PAGE_SEARCH_PLACEHOLDER = 'LEGAL_CASES.PAGE.SEARCH_PLACEHOLDER';
  static readonly LEGAL_CASES_PAGE_TABLE_CASE_NUMBER = 'LEGAL_CASES.PAGE.TABLE_CASE_NUMBER';
  static readonly LEGAL_CASES_PAGE_TABLE_COURT = 'LEGAL_CASES.PAGE.TABLE_COURT';
  static readonly LEGAL_CASES_PAGE_TABLE_CREATED = 'LEGAL_CASES.PAGE.TABLE_CREATED';
  static readonly LEGAL_CASES_PAGE_TABLE_STATUS = 'LEGAL_CASES.PAGE.TABLE_STATUS';
  static readonly LEGAL_CASES_PAGE_TABLE_TYPE = 'LEGAL_CASES.PAGE.TABLE_TYPE';
  static readonly LEGAL_CASES_PAGE_TABLE_CLAIMANT = 'LEGAL_CASES.PAGE.TABLE_CLAIMANT';
  static readonly LEGAL_CASES_PAGE_TABLE_DEFENDANT = 'LEGAL_CASES.PAGE.TABLE_DEFENDANT';
  static readonly LEGAL_CASES_PAGE_TABLE_CLAIMANTS_COUNT = 'LEGAL_CASES.PAGE.TABLE_CLAIMANTS_COUNT';
  static readonly LEGAL_CASES_PAGE_TABLE_DEFENDANTS_COUNT = 'LEGAL_CASES.PAGE.TABLE_DEFENDANTS_COUNT';
  static readonly LEGAL_CASES_PAGE_TABLE_EMPTY_PLACEHOLDER = 'LEGAL_CASES.PAGE.TABLE_EMPTY_PLACEHOLDER';
  static readonly LEGAL_CASES_PAGE_TABLE_TRUNCATION_SUFFIX = 'LEGAL_CASES.PAGE.TABLE_TRUNCATION_SUFFIX';
  /** Max length for claimant/defendant name in table cell before truncation */
  static readonly LEGAL_CASES_TABLE_PARTY_NAME_MAX_LENGTH = 20;
  static readonly LEGAL_CASES_PAGE_TABLE_ACTIONS = 'LEGAL_CASES.PAGE.TABLE_ACTIONS';
  static readonly LEGAL_CASES_PAGE_TABLE_NO_RESULTS = 'LEGAL_CASES.PAGE.TABLE_NO_RESULTS';
  static readonly LEGAL_CASES_PAGINATION_SHOWING = 'LEGAL_CASES.PAGINATION.SHOWING';
  static readonly LEGAL_CASES_PAGINATION_TO = 'LEGAL_CASES.PAGINATION.TO';
  static readonly LEGAL_CASES_PAGINATION_OF = 'LEGAL_CASES.PAGINATION.OF';
  static readonly LEGAL_CASES_PAGINATION_RECORDS = 'LEGAL_CASES.PAGINATION.RECORDS';
  static readonly LEGAL_CASES_PAGINATION_PER_PAGE = 'LEGAL_CASES.PAGINATION.PER_PAGE';
  static readonly LEGAL_CASES_PAGE_TOOLTIP_VIEW = 'LEGAL_CASES.PAGE.TOOLTIP_VIEW';
  static readonly LEGAL_CASES_PAGE_TOOLTIP_EDIT = 'LEGAL_CASES.PAGE.TOOLTIP_EDIT';
  static readonly LEGAL_CASES_PAGE_TOOLTIP_DELETE = 'LEGAL_CASES.PAGE.TOOLTIP_DELETE';
  static readonly LEGAL_CASES_PAGE_DELETE_CONFIRM_HEADER = 'LEGAL_CASES.PAGE.DELETE_CONFIRM_HEADER';
  static readonly LEGAL_CASES_PAGE_DELETE_CONFIRM_MESSAGE = 'LEGAL_CASES.PAGE.DELETE_CONFIRM_MESSAGE';
  static readonly LEGAL_CASES_PAGE_DELETE_ACCEPT = 'LEGAL_CASES.PAGE.DELETE_ACCEPT';
  static readonly LEGAL_CASES_PAGE_DELETE_REJECT = 'LEGAL_CASES.PAGE.DELETE_REJECT';
  static readonly LEGAL_CASES_DETAIL_BACK = 'LEGAL_CASES.DETAIL.BACK';
  static readonly LEGAL_CASES_DETAIL_LOADING = 'LEGAL_CASES.DETAIL.LOADING';
  static readonly LEGAL_CASES_DETAIL_COURT = 'LEGAL_CASES.DETAIL.COURT';
  static readonly LEGAL_CASES_DETAIL_TYPE = 'LEGAL_CASES.DETAIL.TYPE';
  static readonly LEGAL_CASES_DETAIL_STATUS = 'LEGAL_CASES.DETAIL.STATUS';
  static readonly LEGAL_CASES_DETAIL_EDIT_STATUS_TOOLTIP = 'LEGAL_CASES.DETAIL.EDIT_STATUS_TOOLTIP';
  static readonly LEGAL_CASES_DETAIL_CASE_DATA = 'LEGAL_CASES.DETAIL.CASE_DATA';
  static readonly LEGAL_CASES_DETAIL_REPORTING_JUDGE = 'LEGAL_CASES.DETAIL.REPORTING_JUDGE';
  static readonly LEGAL_CASES_DETAIL_PANEL = 'LEGAL_CASES.DETAIL.PANEL';
  static readonly LEGAL_CASES_DETAIL_CLAIMANTS = 'LEGAL_CASES.DETAIL.CLAIMANTS';
  static readonly LEGAL_CASES_DETAIL_DEFENDANTS = 'LEGAL_CASES.DETAIL.DEFENDANTS';
  static readonly LEGAL_CASES_DETAIL_DESCRIPTION = 'LEGAL_CASES.DETAIL.DESCRIPTION';
  static readonly LEGAL_CASES_DETAIL_UPCOMING_ACTIONS = 'LEGAL_CASES.DETAIL.UPCOMING_ACTIONS';
  static readonly LEGAL_CASES_DETAIL_TAB_DOCUMENTS = 'LEGAL_CASES.DETAIL.TAB_DOCUMENTS';
  static readonly LEGAL_CASES_DETAIL_TAB_MOVEMENT = 'LEGAL_CASES.DETAIL.TAB_MOVEMENT';
  static readonly LEGAL_CASES_DETAIL_TAB_PARTIES = 'LEGAL_CASES.DETAIL.TAB_PARTIES';
  static readonly LEGAL_CASES_DETAIL_TAB_TASKS = 'LEGAL_CASES.DETAIL.TAB_TASKS';
  static readonly LEGAL_CASES_DETAIL_DOCUMENTS_TITLE = 'LEGAL_CASES.DETAIL.DOCUMENTS_TITLE';
  static readonly LEGAL_CASES_DETAIL_NO_DOCUMENTS = 'LEGAL_CASES.DETAIL.NO_DOCUMENTS';
  static readonly LEGAL_CASES_DETAIL_PARTIES_TITLE = 'LEGAL_CASES.DETAIL.PARTIES_TITLE';
  static readonly LEGAL_CASES_DETAIL_TASKS_TITLE = 'LEGAL_CASES.DETAIL.TASKS_TITLE';
  static readonly LEGAL_CASES_DETAIL_NO_TASKS = 'LEGAL_CASES.DETAIL.NO_TASKS';
  static readonly LEGAL_CASES_DETAIL_TASKS_LOAD_FAILED_SUMMARY = 'LEGAL_CASES.DETAIL.TASKS_LOAD_FAILED_SUMMARY';
  static readonly LEGAL_CASES_DETAIL_TASKS_LOAD_FAILED_DETAIL = 'LEGAL_CASES.DETAIL.TASKS_LOAD_FAILED_DETAIL';
  static readonly LEGAL_CASES_DETAIL_TIMELINE_TITLE = 'LEGAL_CASES.DETAIL.TIMELINE_TITLE';
  static readonly LEGAL_CASES_DETAIL_HEARINGS_SECTION = 'LEGAL_CASES.DETAIL.HEARINGS_SECTION';
  static readonly LEGAL_CASES_DETAIL_HEARINGS_EMPTY = 'LEGAL_CASES.DETAIL.HEARINGS_EMPTY';
  static readonly LEGAL_CASES_DETAIL_HEARINGS_LOAD_FAILED_SUMMARY = 'LEGAL_CASES.DETAIL.HEARINGS_LOAD_FAILED_SUMMARY';
  static readonly LEGAL_CASES_DETAIL_HEARINGS_LOAD_FAILED_DETAIL = 'LEGAL_CASES.DETAIL.HEARINGS_LOAD_FAILED_DETAIL';
  static readonly LEGAL_CASES_DETAIL_HEARING_DATE = 'LEGAL_CASES.DETAIL.HEARING_DATE';
  static readonly LEGAL_CASES_DETAIL_HEARING_TIME = 'LEGAL_CASES.DETAIL.HEARING_TIME';
  static readonly LEGAL_CASES_DETAIL_HEARING_ROOM = 'LEGAL_CASES.DETAIL.HEARING_ROOM';
  static readonly LEGAL_CASES_DETAIL_HEARING_TYPE = 'LEGAL_CASES.DETAIL.HEARING_TYPE';
  static readonly LEGAL_CASES_DETAIL_HEARING_RESULT = 'LEGAL_CASES.DETAIL.HEARING_RESULT';
  static readonly LEGAL_CASES_DETAIL_HEARING_CANCELED = 'LEGAL_CASES.DETAIL.HEARING_CANCELED';
  static readonly LEGAL_CASES_DETAIL_UPCOMING_HEARING_ON = 'LEGAL_CASES.DETAIL.UPCOMING_HEARING_ON';
  static readonly LEGAL_CASES_DETAIL_UPCOMING_TASK_WITH_DEADLINE = 'LEGAL_CASES.DETAIL.UPCOMING_TASK_WITH_DEADLINE';
  static readonly LEGAL_CASES_DETAIL_UPCOMING_TASK_NO_TITLE = 'LEGAL_CASES.DETAIL.UPCOMING_TASK_NO_TITLE';
  static readonly LEGAL_CASES_DETAIL_UPCOMING_ACTIONS_EMPTY = 'LEGAL_CASES.DETAIL.UPCOMING_ACTIONS_EMPTY';
  static readonly LEGAL_CASES_DETAIL_SIDE_KIND_CLAIMANT_APPELLANT = 'LEGAL_CASES.DETAIL.SIDE_KIND_CLAIMANT_APPELLANT';
  static readonly LEGAL_CASES_DETAIL_SIDE_KIND_CLAIMANT_PLAINTIFF = 'LEGAL_CASES.DETAIL.SIDE_KIND_CLAIMANT_PLAINTIFF';
  static readonly LEGAL_CASES_DETAIL_SIDE_KIND_CLAIMANT_PETITIONER = 'LEGAL_CASES.DETAIL.SIDE_KIND_CLAIMANT_PETITIONER';
  static readonly LEGAL_CASES_DETAIL_SIDE_KIND_DEFENDANT = 'LEGAL_CASES.DETAIL.SIDE_KIND_DEFENDANT';
  static readonly LEGAL_CASES_DIALOG_ADD_TITLE = 'LEGAL_CASES.DIALOG.ADD_TITLE';
  static readonly LEGAL_CASES_DIALOG_EDIT_TITLE = 'LEGAL_CASES.DIALOG.EDIT_TITLE';
  static readonly LEGAL_CASES_DIALOG_ADD_DESCRIPTION = 'LEGAL_CASES.DIALOG.ADD_DESCRIPTION';
  static readonly LEGAL_CASES_DIALOG_EDIT_DESCRIPTION = 'LEGAL_CASES.DIALOG.EDIT_DESCRIPTION';
  static readonly LEGAL_CASES_DIALOG_ENTRY_AUTOMATIC = 'LEGAL_CASES.DIALOG.ENTRY_AUTOMATIC';
  static readonly LEGAL_CASES_DIALOG_ENTRY_MANUAL = 'LEGAL_CASES.DIALOG.ENTRY_MANUAL';
  static readonly LEGAL_CASES_DIALOG_EPEP_SEARCH_TITLE = 'LEGAL_CASES.DIALOG.EPEP_SEARCH_TITLE';
  static readonly LEGAL_CASES_DIALOG_EPEP_CASE_NUMBER = 'LEGAL_CASES.DIALOG.EPEP_CASE_NUMBER';
  static readonly LEGAL_CASES_DIALOG_EPEP_YEAR = 'LEGAL_CASES.DIALOG.EPEP_YEAR';
  static readonly LEGAL_CASES_DIALOG_EPEP_COURT = 'LEGAL_CASES.DIALOG.EPEP_COURT';
  static readonly LEGAL_CASES_DIALOG_EPEP_CASE_TYPE_OPTIONAL = 'LEGAL_CASES.DIALOG.EPEP_CASE_TYPE_OPTIONAL';
  static readonly LEGAL_CASES_DIALOG_EPEP_SELECT_COURT = 'LEGAL_CASES.DIALOG.EPEP_SELECT_COURT';
  static readonly LEGAL_CASES_DIALOG_EPEP_SELECT_TYPE = 'LEGAL_CASES.DIALOG.EPEP_SELECT_TYPE';
  static readonly LEGAL_CASES_DIALOG_EPEP_FETCH_BUTTON = 'LEGAL_CASES.DIALOG.EPEP_FETCH_BUTTON';
  static readonly LEGAL_CASES_DIALOG_EPEP_AFTER_FETCH_HINT = 'LEGAL_CASES.DIALOG.EPEP_AFTER_FETCH_HINT';
  static readonly LEGAL_CASES_DIALOG_EPEP_REFRESH_BUTTON = 'LEGAL_CASES.DIALOG.EPEP_REFRESH_BUTTON';
  static readonly LEGAL_CASES_DIALOG_EPEP_ERROR = 'LEGAL_CASES.DIALOG.EPEP_ERROR';
  static readonly LEGAL_CASES_DIALOG_EPEP_ERROR_MULTIPLE_CASES = 'LEGAL_CASES.DIALOG.EPEP_ERROR_MULTIPLE_CASES';
  static readonly LEGAL_CASES_DIALOG_EPEP_REFRESH_ERROR = 'LEGAL_CASES.DIALOG.EPEP_REFRESH_ERROR';
  static readonly LEGAL_CASES_DIALOG_EPEP_NO_CASES = 'LEGAL_CASES.DIALOG.EPEP_NO_CASES';
  static readonly LEGAL_CASES_DIALOG_CASE_NUMBER_LABEL = 'LEGAL_CASES.DIALOG.CASE_NUMBER_LABEL';
  static readonly LEGAL_CASES_DIALOG_YEAR_LABEL = 'LEGAL_CASES.DIALOG.YEAR_LABEL';
  static readonly LEGAL_CASES_DIALOG_YEAR_PLACEHOLDER = 'LEGAL_CASES.DIALOG.YEAR_PLACEHOLDER';
  static readonly LEGAL_CASES_DIALOG_COURT_LABEL = 'LEGAL_CASES.DIALOG.COURT_LABEL';
  static readonly LEGAL_CASES_DIALOG_CASE_TYPE_LABEL = 'LEGAL_CASES.DIALOG.CASE_TYPE_LABEL';
  static readonly LEGAL_CASES_DIALOG_STATUS = 'LEGAL_CASES.DIALOG.STATUS';
  static readonly LEGAL_CASES_DIALOG_FORMATION_DATE = 'LEGAL_CASES.DIALOG.FORMATION_DATE';
  static readonly LEGAL_CASES_DIALOG_REPORTING_JUDGE = 'LEGAL_CASES.DIALOG.REPORTING_JUDGE';
  static readonly LEGAL_CASES_DIALOG_PANEL = 'LEGAL_CASES.DIALOG.PANEL';
  static readonly LEGAL_CASES_DIALOG_SIDES_TITLE = 'LEGAL_CASES.DIALOG.SIDES_TITLE';
  static readonly LEGAL_CASES_DIALOG_SIDES_LINK_CLIENT_HINT = 'LEGAL_CASES.DIALOG.SIDES_LINK_CLIENT_HINT';
  static readonly LEGAL_CASES_DIALOG_CONTEXT_CLIENT_LABEL = 'LEGAL_CASES.DIALOG.CONTEXT_CLIENT_LABEL';
  static readonly LEGAL_CASES_DIALOG_CONTEXT_CLIENT_BANNER_HINT = 'LEGAL_CASES.DIALOG.CONTEXT_CLIENT_BANNER_HINT';
  static readonly LEGAL_CASES_DIALOG_CONTEXT_ADD_AS_CLAIMANT = 'LEGAL_CASES.DIALOG.CONTEXT_ADD_AS_CLAIMANT';
  static readonly LEGAL_CASES_DIALOG_CONTEXT_ADD_AS_DEFENDANT = 'LEGAL_CASES.DIALOG.CONTEXT_ADD_AS_DEFENDANT';
  static readonly LEGAL_CASES_DIALOG_PLAINTIFFS = 'LEGAL_CASES.DIALOG.PLAINTIFFS';
  static readonly LEGAL_CASES_DIALOG_DEFENDANTS = 'LEGAL_CASES.DIALOG.DEFENDANTS';
  static readonly LEGAL_CASES_DIALOG_CLIENTS_BUTTON = 'LEGAL_CASES.DIALOG.CLIENTS_BUTTON';
  static readonly LEGAL_CASES_DIALOG_ADD_PLAINTIFF = 'LEGAL_CASES.DIALOG.ADD_PLAINTIFF';
  static readonly LEGAL_CASES_DIALOG_ADD_DEFENDANT = 'LEGAL_CASES.DIALOG.ADD_DEFENDANT';
  static readonly LEGAL_CASES_DIALOG_PLAINTIFF_PLACEHOLDER = 'LEGAL_CASES.DIALOG.PLAINTIFF_PLACEHOLDER';
  static readonly LEGAL_CASES_DIALOG_DEFENDANT_PLACEHOLDER = 'LEGAL_CASES.DIALOG.DEFENDANT_PLACEHOLDER';
  static readonly LEGAL_CASES_DIALOG_DESCRIPTION_LABEL = 'LEGAL_CASES.DIALOG.DESCRIPTION_LABEL';
  static readonly LEGAL_CASES_DIALOG_DESCRIPTION_PLACEHOLDER = 'LEGAL_CASES.DIALOG.DESCRIPTION_PLACEHOLDER';
  static readonly LEGAL_CASES_DIALOG_CANCEL = 'LEGAL_CASES.DIALOG.CANCEL';
  static readonly LEGAL_CASES_DIALOG_SAVE = 'LEGAL_CASES.DIALOG.SAVE';
  static readonly LEGAL_CASES_DIALOG_SAVE_CHANGES = 'LEGAL_CASES.DIALOG.SAVE_CHANGES';
  static readonly LEGAL_CASES_DIALOG_CREATE_BUTTON = 'LEGAL_CASES.DIALOG.CREATE_BUTTON';
  static readonly LEGAL_CASES_DIALOG_CLIENT_PICKER_CLAIMANT_TITLE = 'LEGAL_CASES.DIALOG.CLIENT_PICKER_CLAIMANT_TITLE';
  static readonly LEGAL_CASES_DIALOG_CLIENT_PICKER_DEFENDANT_TITLE = 'LEGAL_CASES.DIALOG.CLIENT_PICKER_DEFENDANT_TITLE';
  static readonly LEGAL_CASES_DIALOG_CLIENT_PICKER_SEARCH_PLACEHOLDER = 'LEGAL_CASES.DIALOG.CLIENT_PICKER_SEARCH_PLACEHOLDER';
  static readonly LEGAL_CASES_DIALOG_CLIENT_PICKER_NO_MATCHES = 'LEGAL_CASES.DIALOG.CLIENT_PICKER_NO_MATCHES';
  static readonly LEGAL_CASES_DIALOG_NO_CLIENTS = 'LEGAL_CASES.DIALOG.NO_CLIENTS';
  static readonly LEGAL_CASES_DIALOG_STATUS_ACTIVE = 'LEGAL_CASES.DIALOG.STATUS_ACTIVE';
  static readonly LEGAL_CASES_DIALOG_STATUS_TERMINATED = 'LEGAL_CASES.DIALOG.STATUS_TERMINATED';
  static readonly LEGAL_CASES_DIALOG_STATUS_PAUSED = 'LEGAL_CASES.DIALOG.STATUS_PAUSED';
  static readonly LEGAL_CASES_DIALOG_STATUS_FINISHED = 'LEGAL_CASES.DIALOG.STATUS_FINISHED';

  static readonly LEGAL_CASES_TYPE_PREFIX = 'LEGAL_CASES.TYPE.';
  /** Enum keys for legal case types – used with LEGAL_CASES_TYPE_PREFIX + key; labels come from bg.json */
  static readonly LEGAL_CASES_TYPE_KEYS = [
    'CIVIL_CASE',
    'ADMINISTRATIVE_CASE',
    'CRIMINAL_GENERAL_CASE',
    'CRIMINAL_PRIVATE_CASE',
    'CRIMINAL_SPECIAL_CASE',
    'ADMINISTRATIVE_CRIMINAL_CASE',
    'COMMERCIAL_CASE',
    'PRIVATE_CIVIL_CASE',
    'PRIVATE_COMMERCIAL_CASE',
    'PRIVATE_ADMINISTRATIVE_CASE',
    'EXECUTION_CASE',
    'PRETRIAL_INVESTIGATION',
    'ADMINISTRATIVE_PROCEEDING',
  ] as const;
  static readonly LEGAL_CASES_TYPE_CIVIL_CASE = 'LEGAL_CASES.TYPE.CIVIL_CASE';
  static readonly LEGAL_CASES_TYPE_ADMINISTRATIVE_CASE = 'LEGAL_CASES.TYPE.ADMINISTRATIVE_CASE';
  static readonly LEGAL_CASES_TYPE_CRIMINAL_GENERAL_CASE = 'LEGAL_CASES.TYPE.CRIMINAL_GENERAL_CASE';
  static readonly LEGAL_CASES_TYPE_CRIMINAL_PRIVATE_CASE = 'LEGAL_CASES.TYPE.CRIMINAL_PRIVATE_CASE';
  static readonly LEGAL_CASES_TYPE_CRIMINAL_SPECIAL_CASE = 'LEGAL_CASES.TYPE.CRIMINAL_SPECIAL_CASE';
  static readonly LEGAL_CASES_TYPE_ADMINISTRATIVE_CRIMINAL_CASE = 'LEGAL_CASES.TYPE.ADMINISTRATIVE_CRIMINAL_CASE';
  static readonly LEGAL_CASES_TYPE_COMMERCIAL_CASE = 'LEGAL_CASES.TYPE.COMMERCIAL_CASE';
  static readonly LEGAL_CASES_TYPE_PRIVATE_CIVIL_CASE = 'LEGAL_CASES.TYPE.PRIVATE_CIVIL_CASE';
  static readonly LEGAL_CASES_TYPE_PRIVATE_COMMERCIAL_CASE = 'LEGAL_CASES.TYPE.PRIVATE_COMMERCIAL_CASE';
  static readonly LEGAL_CASES_TYPE_PRIVATE_ADMINISTRATIVE_CASE = 'LEGAL_CASES.TYPE.PRIVATE_ADMINISTRATIVE_CASE';
  static readonly LEGAL_CASES_TYPE_EXECUTION_CASE = 'LEGAL_CASES.TYPE.EXECUTION_CASE';
  static readonly LEGAL_CASES_TYPE_PRETRIAL_INVESTIGATION = 'LEGAL_CASES.TYPE.PRETRIAL_INVESTIGATION';
  static readonly LEGAL_CASES_TYPE_ADMINISTRATIVE_PROCEEDING = 'LEGAL_CASES.TYPE.ADMINISTRATIVE_PROCEEDING';

  static readonly CASE_DETAIL_BACK = 'CASES.DETAIL.BACK';
  static readonly CASE_DETAIL_LOADING = 'CASES.DETAIL.LOADING';
  static readonly CASE_DETAIL_TASKS_OVERVIEW = 'CASES.DETAIL.TASKS_OVERVIEW';
  static readonly CASE_DETAIL_TASKS_TITLE = 'CASES.DETAIL.TASKS_TITLE';
  static readonly CASE_DETAIL_DESCRIPTION = 'CASES.DETAIL.DESCRIPTION';
  static readonly CASE_DETAIL_LINKS = 'CASES.DETAIL.LINKS';
  static readonly CASE_DETAIL_NO_LINKS = 'CASES.DETAIL.NO_LINKS';
  static readonly CASE_DETAIL_DEADLINE = 'CASES.DETAIL.DEADLINE';
  static readonly CASE_DETAIL_ASSIGNEE = 'CASES.DETAIL.ASSIGNEE';
  static readonly CASE_DETAIL_NO_TASKS = 'CASES.DETAIL.NO_TASKS';
  static readonly TASK_STATUS_COMPLETED = 'CASES.DETAIL.TASK_STATUS_COMPLETED';
  static readonly TASK_STATUS_IN_PROGRESS = 'CASES.DETAIL.TASK_STATUS_IN_PROGRESS';
  static readonly TASK_STATUS_PENDING = 'CASES.DETAIL.TASK_STATUS_PENDING';

  static readonly TASK_DETAIL_BACK = 'TASKS.DETAIL.BACK';
  static readonly TASK_DETAIL_LOADING = 'TASKS.DETAIL.LOADING';
  static readonly TASK_DETAIL_DETAILS_LABEL = 'TASKS.DETAIL.DETAILS_LABEL';
  static readonly TASK_DETAIL_DEADLINE = 'TASKS.DETAIL.DEADLINE';
  static readonly TASK_DETAIL_ASSIGNOR = 'TASKS.DETAIL.ASSIGNOR';
  static readonly TASK_DETAIL_ASSIGNEE = 'TASKS.DETAIL.ASSIGNEE';
  static readonly TASK_DETAIL_RELATED_TO = 'TASKS.DETAIL.RELATED_TO';
  static readonly TASK_DETAIL_DESCRIPTION = 'TASKS.DETAIL.DESCRIPTION';
  static readonly TASK_DETAIL_ATTACHED_FILES = 'TASKS.DETAIL.ATTACHED_FILES';
  static readonly TASK_DETAIL_NOTES = 'TASKS.DETAIL.NOTES';
  static readonly TASK_DETAIL_NO_ATTACHED_FILES = 'TASKS.DETAIL.NO_ATTACHED_FILES';
  static readonly TASK_DETAIL_NO_NOTES = 'TASKS.DETAIL.NO_NOTES';
  static readonly TASK_DETAIL_EDIT_DESCRIPTION = 'TASKS.DETAIL.EDIT_DESCRIPTION';
  static readonly TASK_DETAIL_SAVE = 'TASKS.DETAIL.SAVE';
  static readonly TASK_DETAIL_CANCEL = 'TASKS.DETAIL.CANCEL';

  static readonly TASK_DETAIL_NOTES_ADD_BUTTON = 'TASKS.DETAIL.NOTES_ADD_BUTTON';
  static readonly TASK_DETAIL_NOTES_PLACEHOLDER = 'TASKS.DETAIL.NOTES_PLACEHOLDER';
  static readonly TASK_DETAIL_NOTES_CANCEL = 'TASKS.DETAIL.NOTES_CANCEL';
  static readonly TASK_DETAIL_NOTES_SAVE = 'TASKS.DETAIL.NOTES_SAVE';
  static readonly TASK_DETAIL_NOTES_ADD_ACTION = 'TASKS.DETAIL.NOTES_ADD_ACTION';

  static readonly TASK_DETAIL_NOTES_DELETE_CONFIRM_HEADER = 'TASKS.DETAIL.NOTES_DELETE_CONFIRM_HEADER';
  static readonly TASK_DETAIL_NOTES_DELETE_CONFIRM_MESSAGE = 'TASKS.DETAIL.NOTES_DELETE_CONFIRM_MESSAGE';
  static readonly TASK_DETAIL_NOTES_DELETE_ACCEPT = 'TASKS.DETAIL.NOTES_DELETE_ACCEPT';
  static readonly TASK_DETAIL_NOTES_DELETE_REJECT = 'TASKS.DETAIL.NOTES_DELETE_REJECT';
  static readonly TASK_DETAIL_STATUS_COMPLETED = 'TASKS.DETAIL.STATUS_COMPLETED';
  static readonly TASK_DETAIL_STATUS_IN_PROGRESS = 'TASKS.DETAIL.STATUS_IN_PROGRESS';
  static readonly TASK_DETAIL_STATUS_PENDING = 'TASKS.DETAIL.STATUS_PENDING';
  static readonly TASK_DETAIL_EDIT_STATUS_TOOLTIP = 'TASKS.DETAIL.EDIT_STATUS_TOOLTIP';
  static readonly TASKS_PAGE_TITLE = 'TASKS.PAGE.TITLE';
  static readonly TASKS_PAGE_SEARCH_PLACEHOLDER = 'TASKS.PAGE.SEARCH_PLACEHOLDER';
  static readonly TASKS_PAGE_SHOW_COMPLETED = 'TASKS.PAGE.SHOW_COMPLETED';
  static readonly TASKS_PAGE_TABLE_TASK = 'TASKS.PAGE.TABLE_TASK';
  static readonly TASKS_PAGE_TABLE_RELATED_TO = 'TASKS.PAGE.TABLE_RELATED_TO';
  static readonly TASKS_PAGE_TABLE_ASSIGNEE = 'TASKS.PAGE.TABLE_ASSIGNEE';
  static readonly TASKS_PAGE_TABLE_DEADLINE = 'TASKS.PAGE.TABLE_DEADLINE';
  static readonly TASKS_PAGE_TABLE_STATUS = 'TASKS.PAGE.TABLE_STATUS';
  static readonly TASKS_PAGE_TABLE_ACTIONS = 'TASKS.PAGE.TABLE_ACTIONS';
  static readonly TASKS_PAGE_TABLE_NO_RESULTS = 'TASKS.PAGE.TABLE_NO_RESULTS';
  static readonly TASKS_PAGE_TOOLTIP_VIEW = 'TASKS.PAGE.TOOLTIP_VIEW';
  static readonly TASKS_PAGE_TOOLTIP_EDIT = 'TASKS.PAGE.TOOLTIP_EDIT';
  static readonly TASKS_PAGE_TOOLTIP_DELETE = 'TASKS.PAGE.TOOLTIP_DELETE';
  static readonly TASKS_PAGE_DELETE_CONFIRM_HEADER = 'TASKS.PAGE.DELETE_CONFIRM_HEADER';
  static readonly TASKS_PAGE_DELETE_CONFIRM_MESSAGE = 'TASKS.PAGE.DELETE_CONFIRM_MESSAGE';
  static readonly TASKS_PAGE_DELETE_ACCEPT = 'TASKS.PAGE.DELETE_ACCEPT';
  static readonly TASKS_PAGE_DELETE_REJECT = 'TASKS.PAGE.DELETE_REJECT';
  static readonly TASKS_PAGE_STATUS_COMPLETED = 'TASKS.PAGE.STATUS_COMPLETED';
  static readonly TASKS_PAGE_STATUS_IN_PROGRESS = 'TASKS.PAGE.STATUS_IN_PROGRESS';
  static readonly TASKS_PAGE_STATUS_PENDING = 'TASKS.PAGE.STATUS_PENDING';
  static readonly TASKS_PAGE_RELATED_TYPE_CASE = 'TASKS.PAGE.RELATED_TYPE_CASE';
  static readonly TASKS_PAGE_RELATED_TYPE_LEGAL_CASE = 'TASKS.PAGE.RELATED_TYPE_LEGAL_CASE';
  static readonly TASKS_PAGE_RELATED_TYPE_NONE = 'TASKS.PAGE.RELATED_TYPE_NONE';
  static readonly TASKS_PAGINATION_SHOWING = 'TASKS.PAGINATION.SHOWING';
  static readonly TASKS_PAGINATION_TO = 'TASKS.PAGINATION.TO';
  static readonly TASKS_PAGINATION_OF = 'TASKS.PAGINATION.OF';
  static readonly TASKS_PAGINATION_RECORDS = 'TASKS.PAGINATION.RECORDS';
  static readonly TASKS_PAGINATION_PER_PAGE = 'TASKS.PAGINATION.PER_PAGE';
  static readonly TASKS_DIALOG_ADD_TITLE = 'TASKS.DIALOG.ADD_TITLE';
  static readonly TASKS_DIALOG_EDIT_TITLE = 'TASKS.DIALOG.EDIT_TITLE';
  static readonly TASKS_DIALOG_ADD_DESCRIPTION = 'TASKS.DIALOG.ADD_DESCRIPTION';
  static readonly TASKS_DIALOG_EDIT_DESCRIPTION = 'TASKS.DIALOG.EDIT_DESCRIPTION';
  static readonly TASKS_DIALOG_TASK_NAME_LABEL = 'TASKS.DIALOG.TASK_NAME_LABEL';
  static readonly TASKS_DIALOG_TASK_NAME_PLACEHOLDER = 'TASKS.DIALOG.TASK_NAME_PLACEHOLDER';
  static readonly TASKS_DIALOG_DEADLINE_LABEL = 'TASKS.DIALOG.DEADLINE_LABEL';
  static readonly TASKS_DIALOG_DEADLINE_PLACEHOLDER = 'TASKS.DIALOG.DEADLINE_PLACEHOLDER';
  static readonly TASKS_DIALOG_ASSIGNEE_LABEL = 'TASKS.DIALOG.ASSIGNEE_LABEL';
  static readonly TASKS_DIALOG_ASSIGNEE_PLACEHOLDER = 'TASKS.DIALOG.ASSIGNEE_PLACEHOLDER';
  static readonly TASKS_DIALOG_ASSIGNEE_HINT = 'TASKS.DIALOG.ASSIGNEE_HINT';
  static readonly TASKS_DIALOG_STATUS_LABEL = 'TASKS.DIALOG.STATUS_LABEL';
  static readonly TASKS_DIALOG_STATUS_PLACEHOLDER = 'TASKS.DIALOG.STATUS_PLACEHOLDER';
  static readonly TASKS_DIALOG_LINK_TYPE_LABEL = 'TASKS.DIALOG.LINK_TYPE_LABEL';
  static readonly TASKS_DIALOG_LINK_TYPE_NONE = 'TASKS.DIALOG.LINK_TYPE_NONE';
  static readonly TASKS_DIALOG_LINK_TYPE_CASE = 'TASKS.DIALOG.LINK_TYPE_CASE';
  static readonly TASKS_DIALOG_LINK_TYPE_LEGAL_CASE = 'TASKS.DIALOG.LINK_TYPE_LEGAL_CASE';
  static readonly TASKS_DIALOG_LINK_CASE_LABEL = 'TASKS.DIALOG.LINK_CASE_LABEL';
  static readonly TASKS_DIALOG_SELECT_CASE_PLACEHOLDER = 'TASKS.DIALOG.SELECT_CASE_PLACEHOLDER';
  static readonly TASKS_DIALOG_LINK_LEGAL_CASE_LABEL = 'TASKS.DIALOG.LINK_LEGAL_CASE_LABEL';
  static readonly TASKS_DIALOG_SELECT_LEGAL_CASE_PLACEHOLDER = 'TASKS.DIALOG.SELECT_LEGAL_CASE_PLACEHOLDER';
  static readonly TASKS_DIALOG_SELECT_TASK_PLACEHOLDER = 'TASKS.DIALOG.SELECT_TASK_PLACEHOLDER';
  static readonly TASKS_DIALOG_DESCRIPTION_LABEL = 'TASKS.DIALOG.DESCRIPTION_LABEL';
  static readonly TASKS_DIALOG_DESCRIPTION_PLACEHOLDER = 'TASKS.DIALOG.DESCRIPTION_PLACEHOLDER';
  static readonly TASKS_DIALOG_CANCEL = 'TASKS.DIALOG.CANCEL';
  static readonly TASKS_DIALOG_CREATE_BUTTON = 'TASKS.DIALOG.CREATE_BUTTON';
  static readonly TASKS_DIALOG_SAVE_CHANGES = 'TASKS.DIALOG.SAVE_CHANGES';
  static readonly TASKS_DIALOG_CASE_NOT_FOUND = 'TASKS.DIALOG.CASE_NOT_FOUND';

  static readonly FILES_PAGE_TITLE = 'FILES.PAGE.TITLE';
  static readonly FILES_PAGE_SEARCH_PLACEHOLDER = 'FILES.PAGE.SEARCH_PLACEHOLDER';
  static readonly FILES_PAGE_TABLE_FILE_NAME = 'FILES.PAGE.TABLE_FILE_NAME';
  static readonly FILES_PAGE_TABLE_TYPE = 'FILES.PAGE.TABLE_TYPE';
  static readonly FILES_PAGE_TABLE_SIZE = 'FILES.PAGE.TABLE_SIZE';
  static readonly FILES_PAGE_TABLE_RELATED_TO = 'FILES.PAGE.TABLE_RELATED_TO';
  static readonly FILES_PAGE_TABLE_UPLOADED_BY = 'FILES.PAGE.TABLE_UPLOADED_BY';
  static readonly FILES_PAGE_TABLE_UPLOAD_DATE = 'FILES.PAGE.TABLE_UPLOAD_DATE';
  static readonly FILES_PAGE_TABLE_ACTIONS = 'FILES.PAGE.TABLE_ACTIONS';
  static readonly FILES_PAGE_TABLE_NO_RESULTS = 'FILES.PAGE.TABLE_NO_RESULTS';
  static readonly FILES_PAGE_UPLOAD_BUTTON = 'FILES.PAGE.UPLOAD_BUTTON';
  static readonly FILES_PAGE_UPLOAD_ALLOWED_FORMATS = 'FILES.PAGE.UPLOAD_ALLOWED_FORMATS';
  static readonly FILES_PAGE_SELECT_FILE_LABEL = 'FILES.PAGE.SELECT_FILE_LABEL';
  static readonly FILES_PAGE_UPLOAD_DRAG_DROP_HINT = 'FILES.PAGE.UPLOAD_DRAG_DROP_HINT';
  static readonly FILES_PAGE_SELECTED_FILES_SUFFIX = 'FILES.PAGE.SELECTED_FILES_SUFFIX';
  static readonly FILES_PAGE_TOOLTIP_ACTIONS = 'FILES.PAGE.TOOLTIP_ACTIONS';
  static readonly FILES_PAGE_MENU_PREVIEW = 'FILES.PAGE.MENU_PREVIEW';
  static readonly FILES_PAGE_MENU_DOWNLOAD = 'FILES.PAGE.MENU_DOWNLOAD';
  static readonly FILES_PAGE_MENU_DELETE = 'FILES.PAGE.MENU_DELETE';
  static readonly FILES_PAGE_DELETE_CONFIRM_HEADER = 'FILES.PAGE.DELETE_CONFIRM_HEADER';
  static readonly FILES_PAGE_DELETE_CONFIRM_MESSAGE = 'FILES.PAGE.DELETE_CONFIRM_MESSAGE';
  static readonly FILES_PAGE_DELETE_ACCEPT = 'FILES.PAGE.DELETE_ACCEPT';
  static readonly FILES_PAGE_DELETE_REJECT = 'FILES.PAGE.DELETE_REJECT';
  static readonly FILES_PAGE_UPLOAD_MAX_FILES_SUMMARY = 'FILES.PAGE.UPLOAD_MAX_FILES_SUMMARY';
  static readonly FILES_PAGE_UPLOAD_MAX_FILES_DETAIL = 'FILES.PAGE.UPLOAD_MAX_FILES_DETAIL';
  static readonly FILES_PAGE_UPLOAD_TOO_MANY_FILES_DETAIL = 'FILES.PAGE.UPLOAD_TOO_MANY_FILES_DETAIL';
  static readonly FILES_PAGE_UPLOAD_LINK_REQUIRED_SUMMARY = 'FILES.PAGE.UPLOAD_LINK_REQUIRED_SUMMARY';
  static readonly FILES_PAGE_UPLOAD_LINK_REQUIRED_DETAIL = 'FILES.PAGE.UPLOAD_LINK_REQUIRED_DETAIL';
  static readonly FILES_PAGINATION_SHOWING = 'FILES.PAGINATION.SHOWING';
  static readonly FILES_PAGINATION_TO = 'FILES.PAGINATION.TO';
  static readonly FILES_PAGINATION_OF = 'FILES.PAGINATION.OF';
  static readonly FILES_PAGINATION_RECORDS = 'FILES.PAGINATION.RECORDS';
  static readonly FILES_PAGINATION_PER_PAGE = 'FILES.PAGINATION.PER_PAGE';
  static readonly FILES_REF_TYPE_TASK = 'FILES.REF_TYPE.TASK';
  static readonly FILES_REF_TYPE_CASE = 'FILES.REF_TYPE.CASE';
  static readonly FILES_REF_TYPE_LEGAL_CASE = 'FILES.REF_TYPE.LEGAL_CASE';
  static readonly FILES_REF_TYPE_CLIENT = 'FILES.REF_TYPE.CLIENT';
  static readonly FILES_REF_TYPE_NONE = 'FILES.REF_TYPE.NONE';
  static readonly FILES_PAGE_SELECT_CLIENT_PLACEHOLDER = 'FILES.PAGE.SELECT_CLIENT_PLACEHOLDER';

  static readonly DIALOG_UNSAVED_CHANGES_HEADER = 'DIALOG.UNSAVED_CHANGES.HEADER';
  static readonly DIALOG_UNSAVED_CHANGES_MESSAGE = 'DIALOG.UNSAVED_CHANGES.MESSAGE';
  static readonly DIALOG_UNSAVED_CHANGES_DISCARD = 'DIALOG.UNSAVED_CHANGES.DISCARD';
  static readonly DIALOG_UNSAVED_CHANGES_CANCEL = 'DIALOG.UNSAVED_CHANGES.CANCEL';

  static readonly CASE_DIALOG_ADD_TITLE = 'CASES.DIALOG.ADD_TITLE';
  static readonly CASE_DIALOG_EDIT_TITLE = 'CASES.DIALOG.EDIT_TITLE';
  static readonly CASE_DIALOG_ADD_DESCRIPTION = 'CASES.DIALOG.ADD_DESCRIPTION';
  static readonly CASE_DIALOG_EDIT_DESCRIPTION = 'CASES.DIALOG.EDIT_DESCRIPTION';
  static readonly CASE_DIALOG_NAME_LABEL = 'CASES.DIALOG.NAME_LABEL';
  static readonly CASE_DIALOG_NAME_PLACEHOLDER = 'CASES.DIALOG.NAME_PLACEHOLDER';
  static readonly CASE_DIALOG_CONNECTIONS_TITLE = 'CASES.DIALOG.CONNECTIONS_TITLE';
  static readonly CASE_DIALOG_LEGAL_CASE_LABEL = 'CASES.DIALOG.LEGAL_CASE_LABEL';
  static readonly CASE_DIALOG_CLIENT_LABEL = 'CASES.DIALOG.CLIENT_LABEL';
  static readonly CASE_DIALOG_SELECT_LEGAL_CASE = 'CASES.DIALOG.SELECT_LEGAL_CASE';
  static readonly CASE_DIALOG_SELECT_CLIENT = 'CASES.DIALOG.SELECT_CLIENT';
  static readonly CASE_DIALOG_NO_LEGAL_CASE = 'CASES.DIALOG.NO_LEGAL_CASE';
  static readonly CASE_DIALOG_NO_CLIENT = 'CASES.DIALOG.NO_CLIENT';
  static readonly CASE_DIALOG_CONNECTIONS_HINT = 'CASES.DIALOG.CONNECTIONS_HINT';
  static readonly CASE_DIALOG_ADD_BUTTON = 'CASES.DIALOG.ADD_BUTTON';
  static readonly CASE_DIALOG_DETAILS_TITLE = 'CASES.DIALOG.DETAILS_TITLE';
  static readonly CASE_DIALOG_PARTIES_TITLE = 'CASES.DIALOG.PARTIES_TITLE';
  static readonly CASE_DIALOG_PARTIES_HINT = 'CASES.DIALOG.PARTIES_HINT';
  static readonly CASE_DIALOG_PLAINTIFFS = 'CASES.DIALOG.PLAINTIFFS';
  static readonly CASE_DIALOG_DEFENDANTS = 'CASES.DIALOG.DEFENDANTS';
  static readonly CASE_DIALOG_TITLE_LABEL = 'CASES.DIALOG.TITLE_LABEL';
  static readonly CASE_DIALOG_DESCRIPTION_LABEL = 'CASES.DIALOG.DESCRIPTION_LABEL';
  static readonly CASE_DIALOG_CLIENTS_BUTTON = 'CASES.DIALOG.CLIENTS_BUTTON';
  static readonly CASE_DIALOG_ADD_PLAINTIFF = 'CASES.DIALOG.ADD_PLAINTIFF';
  static readonly CASE_DIALOG_ADD_DEFENDANT = 'CASES.DIALOG.ADD_DEFENDANT';
  static readonly CASE_DIALOG_PLAINTIFF_PLACEHOLDER = 'CASES.DIALOG.PLAINTIFF_PLACEHOLDER';
  static readonly CASE_DIALOG_DEFENDANT_PLACEHOLDER = 'CASES.DIALOG.DEFENDANT_PLACEHOLDER';
  static readonly CASE_DIALOG_TITLE_PLACEHOLDER = 'CASES.DIALOG.TITLE_PLACEHOLDER';
  static readonly CASE_DIALOG_DESCRIPTION_PLACEHOLDER = 'CASES.DIALOG.DESCRIPTION_PLACEHOLDER';
  static readonly CASE_DIALOG_CANCEL = 'CASES.DIALOG.CANCEL';
  static readonly CASE_DIALOG_SAVE = 'CASES.DIALOG.SAVE';
  static readonly CASE_DIALOG_SAVE_CHANGES = 'CASES.DIALOG.SAVE_CHANGES';
  static readonly CASE_DIALOG_CLIENT_PICKER_PLAINTIFF_TITLE = 'CASES.DIALOG.CLIENT_PICKER_PLAINTIFF_TITLE';
  static readonly CASE_DIALOG_CLIENT_PICKER_DEFENDANT_TITLE = 'CASES.DIALOG.CLIENT_PICKER_DEFENDANT_TITLE';
  static readonly CASE_DIALOG_NO_CLIENTS = 'CASES.DIALOG.NO_CLIENTS';

  static readonly CASE_DIALOG_ENTRY_AUTOMATIC = 'CASES.DIALOG.ENTRY_AUTOMATIC';
  static readonly CASE_DIALOG_ENTRY_MANUAL = 'CASES.DIALOG.ENTRY_MANUAL';
  static readonly CASE_DIALOG_EPEP_SEARCH_TITLE = 'CASES.DIALOG.EPEP_SEARCH_TITLE';
  static readonly CASE_DIALOG_EPEP_CASE_NUMBER = 'CASES.DIALOG.EPEP_CASE_NUMBER';
  static readonly CASE_DIALOG_EPEP_YEAR = 'CASES.DIALOG.EPEP_YEAR';
  static readonly CASE_DIALOG_EPEP_COURT = 'CASES.DIALOG.EPEP_COURT';
  static readonly CASE_DIALOG_EPEP_CASE_TYPE = 'CASES.DIALOG.EPEP_CASE_TYPE';
  static readonly CASE_DIALOG_EPEP_CASE_TYPE_OPTIONAL = 'CASES.DIALOG.EPEP_CASE_TYPE_OPTIONAL';
  static readonly CASE_DIALOG_EPEP_SELECT_COURT = 'CASES.DIALOG.EPEP_SELECT_COURT';
  static readonly CASE_DIALOG_EPEP_SELECT_TYPE = 'CASES.DIALOG.EPEP_SELECT_TYPE';
  static readonly CASE_DIALOG_EPEP_FETCH_BUTTON = 'CASES.DIALOG.EPEP_FETCH_BUTTON';
  static readonly CASE_DIALOG_EPEP_AFTER_FETCH_HINT = 'CASES.DIALOG.EPEP_AFTER_FETCH_HINT';
  static readonly CASE_DIALOG_STATUS = 'CASES.DIALOG.STATUS';
  static readonly CASE_DIALOG_FORMATION_DATE = 'CASES.DIALOG.FORMATION_DATE';
  static readonly CASE_DIALOG_REPORTING_JUDGE = 'CASES.DIALOG.REPORTING_JUDGE';
  static readonly CASE_DIALOG_PANEL = 'CASES.DIALOG.PANEL';
  static readonly CASE_DIALOG_STATUS_ACTIVE = 'CASES.DIALOG.STATUS_ACTIVE';
  static readonly CASE_DIALOG_STATUS_TERMINATED = 'CASES.DIALOG.STATUS_TERMINATED';
  static readonly CASE_DIALOG_STATUS_PAUSED = 'CASES.DIALOG.STATUS_PAUSED';
  static readonly CASE_DIALOG_STATUS_FINISHED = 'CASES.DIALOG.STATUS_FINISHED';

  static readonly CALENDAR_PAGE_TITLE = 'CALENDAR_MODULE.PAGE.TITLE';
  static readonly CALENDAR_PAGE_SUBTITLE = 'CALENDAR_MODULE.PAGE.SUBTITLE';
  static readonly CALENDAR_TOOLBAR_NEW_APPOINTMENT = 'CALENDAR_MODULE.TOOLBAR.NEW_APPOINTMENT';
  static readonly CALENDAR_TOOLBAR_TODAY = 'CALENDAR_MODULE.TOOLBAR.TODAY';
  static readonly CALENDAR_TOOLBAR_PREVIOUS = 'CALENDAR_MODULE.TOOLBAR.PREVIOUS';
  static readonly CALENDAR_TOOLBAR_NEXT = 'CALENDAR_MODULE.TOOLBAR.NEXT';
  static readonly CALENDAR_FILTERS_TITLE = 'CALENDAR_MODULE.FILTERS.TITLE';
  static readonly CALENDAR_FILTERS_EVENT_TYPE = 'CALENDAR_MODULE.FILTERS.EVENT_TYPE';
  static readonly CALENDAR_FILTERS_EVENT_TYPE_PLACEHOLDER = 'CALENDAR_MODULE.FILTERS.EVENT_TYPE_PLACEHOLDER';
  static readonly CALENDAR_FILTERS_EVENT_TYPES_SELECTED = 'CALENDAR_MODULE.FILTERS.EVENT_TYPES_SELECTED';
  static readonly CALENDAR_FILTERS_EVENT_TYPES_COUNT = 'CALENDAR_MODULE.FILTERS.EVENT_TYPES_COUNT';
  static readonly CALENDAR_FILTERS_EXECUTOR = 'CALENDAR_MODULE.FILTERS.EXECUTOR';
  static readonly CALENDAR_FILTERS_EXECUTOR_PLACEHOLDER = 'CALENDAR_MODULE.FILTERS.EXECUTOR_PLACEHOLDER';
  static readonly CALENDAR_FILTERS_MY_CALENDAR = 'CALENDAR_MODULE.FILTERS.MY_CALENDAR';
  static readonly CALENDAR_FILTERS_CURRENT_USER = 'CALENDAR_MODULE.FILTERS.CURRENT_USER';
  static readonly CALENDAR_FILTERS_TEAM = 'CALENDAR_MODULE.FILTERS.TEAM';
  static readonly CALENDAR_SCOPE_MINE = 'CALENDAR_MODULE.SCOPE.MINE';
  static readonly CALENDAR_SCOPE_FIRM = 'CALENDAR_MODULE.SCOPE.FIRM';
  static readonly CALENDAR_EVENT_TYPE_COURT_HEARING = 'CALENDAR_MODULE.EVENT_TYPES.COURT_HEARING';
  static readonly CALENDAR_EVENT_TYPE_TASK_DEADLINE = 'CALENDAR_MODULE.EVENT_TYPES.TASK_DEADLINE';
  static readonly CALENDAR_EVENT_TYPE_MEETING = 'CALENDAR_MODULE.EVENT_TYPES.MEETING';
  static readonly CALENDAR_EVENT_TYPE_LEAVE = 'CALENDAR_MODULE.EVENT_TYPES.LEAVE';
  static readonly CALENDAR_EVENT_TYPE_OTHER = 'CALENDAR_MODULE.EVENT_TYPES.OTHER';
  static readonly CALENDAR_VIEW_DAY = 'CALENDAR_MODULE.VIEWS.DAY';
  static readonly CALENDAR_VIEW_WEEK = 'CALENDAR_MODULE.VIEWS.WEEK';
  static readonly CALENDAR_VIEW_MONTH = 'CALENDAR_MODULE.VIEWS.MONTH';
  static readonly CALENDAR_MORE_EVENTS = 'CALENDAR_MODULE.CALENDAR.MORE_EVENTS';
  static readonly CALENDAR_FORMAT_DATE = 'CALENDAR_MODULE.FORMATS.DATE';
  static readonly CALENDAR_FORMAT_DATE_TIME = 'CALENDAR_MODULE.FORMATS.DATE_TIME';
  static readonly CALENDAR_FORMAT_TIME = 'CALENDAR_MODULE.FORMATS.TIME';
  static readonly CALENDAR_FORMAT_PRIMENG_DATE = 'CALENDAR_MODULE.FORMATS.PRIMENG_DATE';
  static readonly CALENDAR_DETAILS_TITLE = 'CALENDAR_MODULE.DETAILS.TITLE';
  static readonly CALENDAR_DETAILS_DATE_TIME = 'CALENDAR_MODULE.DETAILS.DATE_TIME';
  static readonly CALENDAR_DETAILS_LOCATION = 'CALENDAR_MODULE.DETAILS.LOCATION';
  static readonly CALENDAR_DETAILS_RELATED_CASE = 'CALENDAR_MODULE.DETAILS.RELATED_CASE';
  static readonly CALENDAR_DETAILS_NOTES = 'CALENDAR_MODULE.DETAILS.NOTES';
  static readonly CALENDAR_DETAILS_EXECUTORS = 'CALENDAR_MODULE.DETAILS.EXECUTORS';
  static readonly CALENDAR_DETAILS_CREATED_BY = 'CALENDAR_MODULE.DETAILS.CREATED_BY';
  static readonly CALENDAR_DETAILS_CLIENT = 'CALENDAR_MODULE.DETAILS.CLIENT';
  static readonly CALENDAR_DETAILS_PERIOD = 'CALENDAR_MODULE.DETAILS.PERIOD';
  static readonly CALENDAR_DETAILS_ONLINE = 'CALENDAR_MODULE.DETAILS.ONLINE';
  static readonly CALENDAR_DETAILS_OFFLINE = 'CALENDAR_MODULE.DETAILS.OFFLINE';
  static readonly CALENDAR_DETAILS_STATUS = 'CALENDAR_MODULE.DETAILS.STATUS';
  static readonly CALENDAR_DETAILS_STATUS_IN_PROGRESS = 'CALENDAR_MODULE.DETAILS.STATUS_IN_PROGRESS';
  static readonly CALENDAR_DETAILS_DESCRIPTION = 'CALENDAR_MODULE.DETAILS.DESCRIPTION';
  static readonly CALENDAR_STATUS_SCHEDULED = 'CALENDAR_MODULE.STATUS.SCHEDULED';
  static readonly CALENDAR_STATUS_COMPLETED = 'CALENDAR_MODULE.STATUS.COMPLETED';
  static readonly CALENDAR_STATUS_CANCELLED = 'CALENDAR_MODULE.STATUS.CANCELLED';
  static readonly CALENDAR_ACTION_EDIT = 'CALENDAR_MODULE.ACTIONS.EDIT';
  static readonly CALENDAR_ACTION_DELETE = 'CALENDAR_MODULE.ACTIONS.DELETE';
  static readonly CALENDAR_ACTION_OPEN_CASE = 'CALENDAR_MODULE.ACTIONS.OPEN_CASE';
  static readonly CALENDAR_ACTION_CLOSE = 'CALENDAR_MODULE.ACTIONS.CLOSE';
  static readonly CALENDAR_ACTION_CANCEL = 'CALENDAR_MODULE.ACTIONS.CANCEL';
  static readonly CALENDAR_ACTION_CREATE = 'CALENDAR_MODULE.ACTIONS.CREATE';
  static readonly CALENDAR_ACTION_SAVE = 'CALENDAR_MODULE.ACTIONS.SAVE';
  static readonly CALENDAR_DIALOG_CREATE_TITLE = 'CALENDAR_MODULE.DIALOG.CREATE_TITLE';
  static readonly CALENDAR_DIALOG_EDIT_TITLE = 'CALENDAR_MODULE.DIALOG.EDIT_TITLE';
  static readonly CALENDAR_DIALOG_TITLE_LABEL = 'CALENDAR_MODULE.DIALOG.TITLE_LABEL';
  static readonly CALENDAR_DIALOG_TITLE_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.TITLE_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_TYPE_LABEL = 'CALENDAR_MODULE.DIALOG.TYPE_LABEL';
  static readonly CALENDAR_DIALOG_TYPE_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.TYPE_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_TYPE_HINT = 'CALENDAR_MODULE.DIALOG.TYPE_HINT';
  static readonly CALENDAR_DIALOG_DATE_LABEL = 'CALENDAR_MODULE.DIALOG.DATE_LABEL';
  static readonly CALENDAR_DIALOG_START_LABEL = 'CALENDAR_MODULE.DIALOG.START_LABEL';
  static readonly CALENDAR_DIALOG_END_LABEL = 'CALENDAR_MODULE.DIALOG.END_LABEL';
  static readonly CALENDAR_DIALOG_ALL_DAY_LABEL = 'CALENDAR_MODULE.DIALOG.ALL_DAY_LABEL';
  static readonly CALENDAR_DIALOG_LOCATION_LABEL = 'CALENDAR_MODULE.DIALOG.LOCATION_LABEL';
  static readonly CALENDAR_DIALOG_LOCATION_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.LOCATION_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_NOTES_LABEL = 'CALENDAR_MODULE.DIALOG.NOTES_LABEL';
  static readonly CALENDAR_DIALOG_NOTES_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.NOTES_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_DESCRIPTION_LABEL = 'CALENDAR_MODULE.DIALOG.DESCRIPTION_LABEL';
  static readonly CALENDAR_DIALOG_DESCRIPTION_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.DESCRIPTION_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_RELATED_CASE_LABEL = 'CALENDAR_MODULE.DIALOG.RELATED_CASE_LABEL';
  static readonly CALENDAR_DIALOG_RELATED_CASE_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.RELATED_CASE_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_CLIENT_LABEL = 'CALENDAR_MODULE.DIALOG.CLIENT_LABEL';
  static readonly CALENDAR_DIALOG_CLIENT_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.CLIENT_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_EXECUTORS_LABEL = 'CALENDAR_MODULE.DIALOG.EXECUTORS_LABEL';
  static readonly CALENDAR_DIALOG_EXECUTOR_PLACEHOLDER = 'CALENDAR_MODULE.DIALOG.EXECUTOR_PLACEHOLDER';
  static readonly CALENDAR_DIALOG_ONLINE_LABEL = 'CALENDAR_MODULE.DIALOG.ONLINE_LABEL';
  static readonly CALENDAR_VALIDATION_REQUIRED = 'CALENDAR_MODULE.VALIDATION.REQUIRED';
  static readonly CALENDAR_VALIDATION_END_AFTER_START = 'CALENDAR_MODULE.VALIDATION.END_AFTER_START';
  static readonly CALENDAR_VALIDATION_RESPONSIBLE_EXECUTOR_REQUIRED = 'CALENDAR_MODULE.VALIDATION.RESPONSIBLE_EXECUTOR_REQUIRED';
  static readonly CALENDAR_ERROR_LOAD_EXECUTORS = 'CALENDAR_MODULE.ERRORS.LOAD_EXECUTORS';
  static readonly CALENDAR_ERROR_LOAD_CURRENT_USER = 'CALENDAR_MODULE.ERRORS.LOAD_CURRENT_USER';
  static readonly CALENDAR_CONFIRM_DELETE_HEADER = 'CALENDAR_MODULE.CONFIRM.DELETE_HEADER';
  static readonly CALENDAR_CONFIRM_DELETE_MESSAGE = 'CALENDAR_MODULE.CONFIRM.DELETE_MESSAGE';
  static readonly CALENDAR_TOAST_CREATED_SUMMARY = 'CALENDAR_MODULE.TOAST.CREATED_SUMMARY';
  static readonly CALENDAR_TOAST_CREATED_DETAIL = 'CALENDAR_MODULE.TOAST.CREATED_DETAIL';
  static readonly CALENDAR_TOAST_UPDATED_SUMMARY = 'CALENDAR_MODULE.TOAST.UPDATED_SUMMARY';
  static readonly CALENDAR_TOAST_UPDATED_DETAIL = 'CALENDAR_MODULE.TOAST.UPDATED_DETAIL';
  static readonly CALENDAR_TOAST_DELETED_SUMMARY = 'CALENDAR_MODULE.TOAST.DELETED_SUMMARY';
  static readonly CALENDAR_TOAST_DELETED_DETAIL = 'CALENDAR_MODULE.TOAST.DELETED_DETAIL';
  static readonly CALENDAR_TOAST_LOAD_ERROR_SUMMARY = 'CALENDAR_MODULE.TOAST.LOAD_ERROR_SUMMARY';
  static readonly CALENDAR_TOAST_LOAD_ERROR_DETAIL = 'CALENDAR_MODULE.TOAST.LOAD_ERROR_DETAIL';
  static readonly CALENDAR_TOAST_DETAIL_ERROR_DETAIL = 'CALENDAR_MODULE.TOAST.DETAIL_ERROR_DETAIL';
  static readonly CALENDAR_TOAST_SAVE_ERROR_SUMMARY = 'CALENDAR_MODULE.TOAST.SAVE_ERROR_SUMMARY';
  static readonly CALENDAR_TOAST_CREATE_ERROR_DETAIL = 'CALENDAR_MODULE.TOAST.CREATE_ERROR_DETAIL';
  static readonly CALENDAR_TOAST_UPDATE_ERROR_DETAIL = 'CALENDAR_MODULE.TOAST.UPDATE_ERROR_DETAIL';
  static readonly CALENDAR_TOAST_CANCEL_ERROR_SUMMARY = 'CALENDAR_MODULE.TOAST.CANCEL_ERROR_SUMMARY';
  static readonly CALENDAR_TOAST_CANCEL_ERROR_DETAIL = 'CALENDAR_MODULE.TOAST.CANCEL_ERROR_DETAIL';
  static readonly CALENDAR_TOAST_EDIT_FORBIDDEN_SUMMARY = 'CALENDAR_MODULE.TOAST.EDIT_FORBIDDEN_SUMMARY';
  static readonly CALENDAR_TOAST_EDIT_FORBIDDEN_DETAIL = 'CALENDAR_MODULE.TOAST.EDIT_FORBIDDEN_DETAIL';
  static readonly CALENDAR_TOAST_DELETE_FORBIDDEN_SUMMARY = 'CALENDAR_MODULE.TOAST.DELETE_FORBIDDEN_SUMMARY';
  static readonly CALENDAR_TOAST_DELETE_FORBIDDEN_DETAIL = 'CALENDAR_MODULE.TOAST.DELETE_FORBIDDEN_DETAIL';
  static readonly CALENDAR_EMPTY_DETAILS = 'CALENDAR_MODULE.EMPTY.DETAILS';
}
